<template lang="pug">
.bq-dashboard
    //.bq-dash-header
        .bq-dash-title
            span.bq-badge(:class="currentService.formattedSpecs.currentPlan.label.toLowerCase().split(' ')[0]") {{ currentService.formattedSpecs.currentPlan.label }}
            h2.bq-title {{ currentService.service.name }}

    //.bq-section
        //- h2.bq-section-title Project Information

    //- editable fields
    .bq-meta(:class="{ disabled: settingsLocked }")
        h2.bq-section-title Project

        .bq-row
            //- .bq-row-label Service Name
            //- .bq-row-value {{ currentService.service.name }}
            .bq-toggle-label
                span Name
                small.bq-toggle-hint(translate="no") {{ currentService.service.name }}
            
            a.bq-link(
                @click="editName"
                :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
            ) [Edit]

        //- .bq-row
        //-     .bq-toggle-label
        //-         span CORS
        //-         small.bq-toggle-hint {{ currentService.service.cors || "*" }}
            
        //-     a.bq-link(
        //-         @click="editCors"
        //-         :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
        //-     ) [Edit]

        .bq-row
            .bq-toggle-label
                span Base Prompt
                small.bq-toggle-hint(translate="no") {{ currentService.service.description || "No Base Prompt" }}
            
            a.bq-link(
                @click="editDescription"
                :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
            ) [Edit]

        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Disable/Enable
        //-         small.bq-toggle-hint When disabled, users cannot access the database.
        //-     Toggle(
        //-         :disabled="!!(currentService.service?.will_terminate || updatingValue.enableDisable)"
        //-         :active="currentService.service.active >= 1"
        //-         @click="enableDisable"
        //-     )

        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Allow Signup
        //-         small.bq-toggle-hint When disallowed, only the administrator can create accounts.
        //-     Toggle(
        //-         :active="!currentService.service.prevent_signup"
        //-         :disabled="currentService.service.active < 0 || updatingValue.prevent_signup"
        //-         @click="changeCreateUserMode(!currentService.service.prevent_signup)"
        //-     )

        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Prevent Inquiry
        //-         small.bq-toggle-hint When prevented, users cannot send inquiries to this service.
        //-     Toggle(
        //-         :active="currentService.service.prevent_inquiry"
        //-         :disabled="currentService.service.active < 0 || updatingValue.prevent_inquiry"
        //-         @click="changePreventInquiry(!currentService.service.prevent_inquiry)"
        //-     )

        //- prevent_anonymous is a skapi-level flag governing anonymous record
        //- WRITES. BunnyQuery does not surface it: its MCP refuses anonymous
        //- writes unconditionally. The chat's login wall is "Require login" in
        //- Advanced, which is a separate setting.

    .bq-meta

            //- h2.bq-section-title {{ currentService.service.name }}
            h2.bq-section-title Information
            //- span.bq-badge(:class="currentService.formattedSpecs.currentPlan.label.toLowerCase().split(' ')[0]") {{ currentService.formattedSpecs.currentPlan.label }}
            //- h2.bq-title {{ currentService.service.name }}

            .bq-meta-row
                span Project ID
                span.bq-mono(translate="no") {{ currentService.service.projectId }}
            .bq-meta-row
                span Owner ID
                span.bq-mono(translate="no") {{ currentService.service.owner }}
            .bq-meta-row
                span Service ID
                span.bq-mono(translate="no") {{ currentService.service.service }}
            .bq-meta-row
                span Region
                span.bq-mono(translate="no") {{ regionText(currentService.service.region) }}
            .bq-meta-row
                span Created
                span {{ dateFormat(currentService.dateCreated) }}
            //- .bq-meta-row
            //-     span Hosting
            //-     span.bq-mono {{ currentService.service.subdomain ? currentService.service.subdomain + ".bunnyquery.com" : "N/A" }}
            //- .bq-meta-row
            //-     span MCP Endpoint
            //-     //- span.bq-mono {{ MCP_BASE_URL }}
            //-     span.bq-mono
            //-         a.bq-link(
            //-             style="left:0"
            //-             v-if="currentService.service.subdomain"
            //-             :href="MCP_BASE_URL" translate="no"
            //-             target="_blank"
            //-             rel="noopener noreferrer"
            //-         ) {{ MCP_BASE_URL }}
            //- The widget address used to live here, as one grey line among
            //- five. It is now the card at the top of the page, with its own
            //- copy button; a second copy of it here would only compete with it.
            //- .bq-meta-row
            //-     span Email
            //-     span.bq-mono {{ (currentService.service.email_alias || currentService.service.service) + "@mail.skapi.com" }}

    //- //- service ID
    //- .bq-section
    //-     .bq-row
    //-         .bq-row-label Service ID
    //-         .bq-row-value.bq-mono {{ currentService.service.projectId }}
    //-         a.bq-link(@click="copy(currentService.service.projectId)") [Copy]

    //- The project's public chat address. This is the one thing an owner comes
    //- to this page to hand to somebody else, so it leads the page with its own
    //- copy button instead of sitting as a line inside "Information" further
    //- down, where it was easy to miss.
    section.bq-share(v-if="widgetSubdomain")
        .bq-share-head
            span.bq-share-title Chat Widget
            small.bq-share-hint The BunnyQuery chat widget for this project. Share the address so others can chat with your data.
        .bq-share-bar
            a.bq-share-url(
                :href="widgetUrl"
                target="_blank"
                rel="noopener noreferrer"
                translate="no"
                :class="{ disabled: !widgetLinkLive }"
            ) {{ widgetUrlLabel }}
            .bq-share-actions
                button.bq-share-btn(
                    type="button"
                    @click="copyWidgetLink"
                    :class="{ copied: widgetLinkCopied }"
                )
                    //- Both glyphs are already in index.html's `icon_names=`
                    //- allowlist; a name outside it renders as literal text.
                    span.material-symbols-outlined.bq-share-btn-icon(translate="no") {{ widgetLinkCopied ? 'check_circle' : 'content_copy' }}
                    span {{ widgetLinkCopied ? 'Copied' : 'Copy link' }}
                //- a.bq-share-btn.bq-share-btn--ghost(
                //-     :href="widgetUrl"
                //-     target="_blank"
                //-     rel="noopener noreferrer"
                //-     :class="{ disabled: !widgetLinkLive }"
                //- ) Open
        small.bq-share-note(v-if="widgetLinkNote") {{ widgetLinkNote }}

    section.bq-share.bq-share--empty(v-else)
        .bq-share-head
            span.bq-share-title Chat Widget
            small.bq-share-hint This project has no chat address yet. Set up web hosting on #[a(href="https://www.skapi.com") Skapi] to give your widget a link you can share.


    //- plan + usage
    .bq-meta
        h2.bq-section-title Plan &amp; Usage
        .bq-plan-header
            span.bq-badge(:class="currentService.formattedSpecs.currentPlan.label.toLowerCase().split(' ')[0]") {{ currentService.formattedSpecs.currentPlan.label }}
            span.bq-renew(v-if="currentService.subscription?.current_period_end && currentService.formattedSpecs.currentPlan.label.toLowerCase() !== 'free' && currentService.formattedSpecs.serviceStatus.canChangePlan && !currentService.subscription?.will_cancel && currentService.service.active === 1 && currentService.subscription?.status !== 'past_due'") Renews {{ dateFormat(currentService.subscription?.current_period_end * 1000) }}

        //- .bq-meta
        //-     .bq-meta-row
        //-         span Project ID
        //-         span.bq-mono {{ currentService.service.projectId }}
        //-     .bq-meta-row
        //-         span Resource
        //-         span.bq-mono {{ currentService.service.service }}
        //-     .bq-meta-row
        //-         span Region
        //-         span.bq-mono {{ currentService.service.region }}
        //-     .bq-meta-row
        //-         span Created
        //-         span {{ dateFormat(currentService.dateCreated) }}
        //-     .bq-meta-row
        //-         span Hosting
        //-         span.bq-mono {{ currentService.service.subdomain ? currentService.service.subdomain + ".skapi.com" : "N/A" }}
        //-     .bq-meta-row
        //-         span Email
        //-         span.bq-mono {{ (currentService.service.email_alias || currentService.service.service) + "@mail.skapi.com" }}

        .bq-usage-bars
            .bq-usage-item
                .bq-usage-head
                    span Users (Collaborators)
                    span {{ currentService.formattedSpecs.serviceStatus.users_string || 0 }} / {{ currentService.formattedSpecs.currentPlan.users_string }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.users_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.users_percent)")

            .bq-usage-item
                .bq-usage-head
                    span Database
                    span {{ currentService.formattedSpecs.serviceStatus.storage.database }} / {{ currentService.formattedSpecs.currentPlan.storage.database }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.database_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.database_percent)")

            //- One bar for the file pool: hosting, cloud files and the BunnyQuery
            //- index share the plan's ceiling, so they are drawn as three coloured
            //- segments of the same track, and the legend names each share.
            .bq-usage-item
                .bq-usage-head
                    span File Storage
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.pool }} / {{ currentService.formattedSpecs.currentPlan.storage.pool }}
                .bq-bar.bq-bar--stacked(:class="poolTrackClass(currentService.formattedSpecs.serviceStatus.storage.pool_percent)")
                    .bq-bar-seg.bq-bar-seg--host(:style="{ width: currentService.formattedSpecs.serviceStatus.storage.segments.host.width }")
                    .bq-bar-seg.bq-bar-seg--cloud(:style="{ width: currentService.formattedSpecs.serviceStatus.storage.segments.cloud.width }")
                    .bq-bar-seg.bq-bar-seg--file(:style="{ width: currentService.formattedSpecs.serviceStatus.storage.segments.file.width }")
                .bq-usage-legend
                    span.bq-legend-item
                        i.bq-legend-dot.bq-bar-seg--host
                        | Hosting
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.segments.host.text }}
                    span.bq-legend-item
                        i.bq-legend-dot.bq-bar-seg--cloud
                        | Cloud storage
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.segments.cloud.text }}
                    span.bq-legend-item
                        i.bq-legend-dot.bq-bar-seg--file
                        | BunnyQuery storage
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.segments.file.text }}

            //- Sent newsletters are stored against the plan's email storage, so
            //- it gets a meter here once the project stores any (newsletters
            //- are sent from the Skapi dashboard). A region still serving a
            //- limit of 0 draws it against the amount it suspends above.
            .bq-usage-item(v-if="currentService.formattedSpecs.serviceStatus.storage.email_bytes > 0")
                .bq-usage-head
                    span Email Storage
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.storage.email }} / {{ currentService.formattedSpecs.serviceStatus.storage.email_limit_zero ? 'none included' : currentService.formattedSpecs.currentPlan.storage.email }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.email_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.email_percent)")
                //- What happens when it is full, for this plan; the rule for
                //- every plan is behind the link (code/plan-copy.ts
                //- emailStorageMeterNote).
                .bq-usage-legend
                    span
                        | {{ storageNote.text + " " }}
                        a.bq-cta-link(:href="storageNote.href" target="_blank" rel="noopener") Learn more

            //- Metered per MONTH, unlike the levels above. Drawn only when the
            //- plan quotes a ceiling: egress_bytes is 0 for Unlimited and NaN
            //- until GET /plan answers, and neither is a bar.
            .bq-usage-item(v-if="currentService.formattedSpecs.currentPlan.egress_bytes > 0")
                .bq-usage-head
                    span Bandwidth (this month)
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.usage_month.egress }} / {{ currentService.formattedSpecs.currentPlan.egress }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.usage_month.egress_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.usage_month.egress_percent)")
                //- Metered now; enforcement and Premium billing ship switched off
                //- (GET /plan switches), so say which one is still off.
                .bq-usage-legend(v-if="bandwidthMeterNote(currentService.formattedSpecs.currentPlan.hard_stop)")
                    span
                        | {{ bandwidthMeterNote(currentService.formattedSpecs.currentPlan.hard_stop) + " " }}
                        a.bq-cta-link(:href="PLAN_DOCS.bandwidth" target="_blank" rel="noopener") Learn more

            .bq-usage-item(v-if="currentService.formattedSpecs.currentPlan.email_sends > 0")
                .bq-usage-head
                    span Email sends (this month)
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.usage_month.email_sends }} / {{ currentService.formattedSpecs.currentPlan.email_sends_string }}
                .bq-bar
                    .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.usage_month.email_sends_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.usage_month.email_sends_percent)")
                //- One line: a block in force (spam complaints, sends used up),
                //- else how a send is counted. The rest of the rules (the
                //- per-owner cap, the complaint shutoff) are behind the link
                //- (code/plan-copy.ts emailSendsMeterNote).
                .bq-usage-legend
                    span(:class="{ 'bq-usage-alert': sendsNote.danger }")
                        | {{ sendsNote.text + " " }}
                        a.bq-cta-link(:href="sendsNote.href" target="_blank" rel="noopener") Learn more

            //- .bq-usage-item
            //-     .bq-usage-head
            //-         span Cloud Storage
            //-         span {{ currentService.formattedSpecs.serviceStatus.storage.cloud }} / {{ currentService.formattedSpecs.currentPlan.storage.cloud }}
            //-     .bq-bar
            //-         .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.cloud_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.cloud_percent)")

            //- .bq-usage-item
            //-     .bq-usage-head
            //-         span Email Storage
            //-         span {{ currentService.formattedSpecs.serviceStatus.storage.email }} / {{ currentService.formattedSpecs.currentPlan.storage.email }}
            //-     .bq-bar
            //-         .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.email_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.email_percent)")

            //- .bq-usage-item
            //-     .bq-usage-head
            //-         span Hosting
            //-         span {{ currentService.formattedSpecs.serviceStatus.storage.host }} / {{ currentService.formattedSpecs.currentPlan.storage.host }}
            //-     .bq-bar
            //-         .bq-bar-fill(:style="{ width: barWidth(currentService.formattedSpecs.serviceStatus.storage.host_percent) }" :class="barColor(currentService.formattedSpecs.serviceStatus.storage.host_percent)")
            
            //- The alignment lives on the wrapper, not on the link: as a
            //- right-aligned BLOCK the link stretched the full card width, so
            //- the empty space left of the button was clickable too.
            .bq-plan-cta
                router-link(
                    :to="`/subscription/${currentService.id}`"
                )
                    button {{ planCtaLabel(currentService) }}

        //- A suspended project: which limits are over, by how much, and where the
        //- data can be deleted (code/plan-copy.ts suspendedLimitRows).
        .bq-overage(v-if="suspendRows.length")
            h3.bq-overage-title Over the limit
            .bq-row(v-for="r in suspendRows" :key="r.key")
                .bq-toggle-label
                    span {{ STORED_LIMIT_LABEL[r.key] }}
                    small.bq-toggle-hint(translate="no") {{ r.text }}
                    small.bq-toggle-hint(v-if="r.hint") {{ r.hint }}
                router-link.bq-link(v-if="r.action?.to" :to="r.action.to") [{{ r.action.label }}]
                a.bq-link(v-else-if="r.action?.href" :href="r.action.href" target="_blank" rel="noopener") [{{ r.action.label }}]

        //- What happens past a limit. A plan without a hard stop is billed for
        //- the excess, and the OverageMeter job writes the month to date onto
        //- the service row (service.ovg); a hard stop plan just pauses. Unlimited
        //- has no limits to pass, so it draws neither block.
        .bq-overage(v-if="currentService.formattedSpecs.currentPlan.hard_stop === false && currentService.formattedSpecs.currentPlan.label !== 'Unlimited'")
            h3.bq-overage-title Overage (month to date)
            template(v-if="currentService.formattedSpecs.serviceStatus.overage")
                .bq-meta-row(v-for="row in currentService.formattedSpecs.serviceStatus.overage.rows" :key="row.metric")
                    span {{ row.label }}
                    span(translate="no") {{ row.over }} over, {{ row.cost }}
                .bq-meta-row.bq-overage-total
                    span Total
                    span(translate="no") {{ currentService.formattedSpecs.serviceStatus.overage.total }}
                p.bq-overage-note
                    | {{ currentService.formattedSpecs.serviceStatus.overage.billable ? "Billed with your next invoice" : "Not billed on this plan" }}
                    template(v-if="currentService.formattedSpecs.serviceStatus.overage.sampled")
                        | , sampled 
                        span(translate="no") {{ currentService.formattedSpecs.serviceStatus.overage.sampled }}
            p.bq-overage-note(v-else) No overage recorded yet
        p.bq-overage-note.bq-overage-note--alone(v-else-if="currentService.formattedSpecs.currentPlan.hard_stop !== false")
            | {{ hardStopNote() + " " }}
            a.bq-cta-link(:href="PLAN_DOCS.hardStop" target="_blank" rel="noopener") Learn more
    //- AI Agent API
    .bq-meta(:class="{ disabled: settingsLocked }")
        h2.bq-section-title Query API

        .bq-row
            .bq-toggle-label(style='min-width: 6rem;')
                span AI Platform
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleAiPlatformMenu" :disabled="settingsLocked" :class="{ open: aiPlatformMenuOpen }")
                    span.bq-ai-select-value
                        img.bq-ai-logo(v-if="selectedAiPlatform.logo" :src="selectedAiPlatform.logo" :alt="selectedAiPlatform.label")
                        span {{ selectedAiPlatform.label }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(v-if="isMobile" v-model="aiPlatform" :disabled="settingsLocked" aria-label="AI Platform")
                    option(value="none") None
                    option(value="openai") ChatGPT
                    option(value="claude") Claude
                .bq-ai-options(v-if="!isMobile && aiPlatformMenuOpen")
                    button.bq-ai-option(
                        v-for="option in aiPlatformOptions"
                        :key="option.value"
                        type="button"
                        @mousedown.prevent
                        @click="selectAiPlatform(option.value)"
                        :class="{ active: aiPlatform === option.value }"
                    )
                        img.bq-ai-logo(v-if="option.logo" :src="option.logo" :alt="option.label")
                        span {{ option.label }}

        .bq-row(:class="{ disabled: aiPlatform === 'none' || fetchingAiModels || !aiModels.length }")
            .bq-toggle-label(style='min-width: 6rem;')
                span Model
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleModelMenu" :disabled="fetchingAiModels" :class="{ open: modelMenuOpen }")
                    span.bq-ai-select-value
                        span(v-if="fetchingAiModels") Loading...
                        span(v-else-if="aiModelsError && aiPlatform !== 'none'") Invalid API Key
                        span(v-else-if="!aiModels.length && aiPlatform !== 'none'") No models
                        span(v-else translate="no") {{ selectedModelLabel }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(v-if="isMobile && aiModels.length" :value="selectedModel" @change="selectModel($event.target.value)" :disabled="fetchingAiModels" aria-label="AI Model")
                    option(v-for="m in aiModels" :key="m.id" :value="m.id" translate="no") {{ m.display_name || m.id }}
                .bq-ai-options.bq-model-options(v-if="!isMobile && modelMenuOpen")
                    button.bq-ai-option(
                        v-for="m in aiModels"
                        :key="m.id"
                        type="button"
                        @mousedown.prevent
                        @click="selectModel(m.id)"
                        :class="{ active: selectedModel === m.id }"
                    )
                        span(translate="no") {{ m.display_name || m.id }}

        .bq-row(:class="{ disabled: aiPlatform === 'none' || !selectedModel }")
            .bq-toggle-label(style='min-width: 6rem;')
                span Input context window
                small.bq-toggle-hint {{ contextWindowHint }}
            .bq-ai-select.bq-ai-select--wide(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleContextMenu" :disabled="!selectedModel" :class="{ open: contextMenuOpen }")
                    span.bq-ai-select-value
                        span(translate="no") {{ selectedContextLabel }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(
                    v-if="isMobile && selectedModel"
                    :value="selectedContextWindow === null ? '' : String(selectedContextWindow)"
                    @change="selectContextWindow($event.target.value)"
                    aria-label="Input context window"
                )
                    option(v-for="o in contextWindowOptions" :key="o.label" :value="o.value === null ? '' : String(o.value)" translate="no") {{ o.label }}
                .bq-ai-options(v-if="!isMobile && contextMenuOpen")
                    button.bq-ai-option(
                        v-for="o in contextWindowOptions"
                        :key="o.label"
                        type="button"
                        @mousedown.prevent
                        @click="selectContextWindow(o.value)"
                        :class="{ active: selectedContextWindow === o.value }"
                    )
                        span(translate="no") {{ o.label }}

        .bq-row.bq-api-key-row(:class="{ disabled: aiPlatform === 'none' }")
            .bq-toggle-label
                span API Key
                small.bq-toggle-hint.bq-api-key-value
                    span.bq-api-key-slot(v-if="fetchingAiApiKey")
                        span.bq-loader Loading
                    span.bq-api-key-slot(v-else translate="no") {{ aiApiKey ? aiApiKey.slice(0, 2) + '******...' : 'Not set' }}
            a.bq-link(
                @click="editAiApiKey"
                :class="{ disabled: aiPlatform === 'none' || fetchingAiApiKey || loadingAiApiKey }"
            ) <span v-if="loadingAiApiKey">[{{ aiApiKeyLoadingDots }}]</span><span v-else>[Edit]</span>

    //- Advanced (expert tools)
    .bq-meta(:class="{ disabled: settingsLocked }")
        h2.bq-section-title Advanced

        .bq-row
            .bq-toggle-label
                span Database
                small.bq-toggle-hint Browse and edit records in this project's database.
            router-link.bq-link(
                :to="`/my-projects/${currentService.id}/records`"
                :class="{ disabled: !user?.email_verified || currentService.service.active < 0 }"
            ) [Open]

        //- The chat page this project serves at <subdomain>. Its version is not
        //- stored anywhere per service, so it is scraped from the hosted HTML.
        //- Every update first saves the page it replaces, and [Revert] puts that
        //- one back. The second hint line only exists once there is something
        //- saved, so a project that was never updated reads as it always did.
        .bq-row
            .bq-toggle-label
                span Chat Widget Version
                small.bq-toggle-hint(v-if="widgetError" translate="no") {{ widgetError }}
                small.bq-toggle-hint(v-else translate="no") {{ widgetVersionLabel }}
                small.bq-toggle-hint(v-if="widgetBackupLabel" translate="no") {{ widgetBackupLabel }}
            .bq-row-actions
                a.bq-link(
                    @click="askRevertWidget"
                    :class="{ disabled: !canRevertWidget }"
                )
                    span(v-if="updatingValue.widgetRevert") [Reverting]
                    span(v-else) [Revert]
                a.bq-link(
                    @click="updateWidget"
                    :class="{ disabled: !canUpdateWidget }"
                )
                    span(v-if="updatingValue.widget") [Updating]
                    span(v-else) [Update]

        //- The line the chat opens with, held in the SAME "bq::settings" record
        //- as the "Default access" setting (its own `chat_greeting` key, so one
        //- fetch reads both, wherever the two rows sit on the page). Empty means
        //- the built-in sentence, which is what every project had before this
        //- setting existed, so a project that never opens this is unchanged.
        .bq-row
            .bq-toggle-label
                span Chat Intro
                //- Until the settings record has been read, "" is indistinguishable
                //- from "this project has never set one", and the row would state
                //- "Default intro message" as though that were the fetched answer.
                //- Say we are still looking instead, and hold Edit shut: opening it
                //- early would put an empty textarea in front of an owner who does
                //- have a custom line, and saving that would wipe it.
                small.bq-toggle-hint(v-if="!projectSettingsLoaded") Loading...
                small.bq-toggle-hint(v-else translate="no") {{ chatGreetingLabel }}

            a.bq-link(
                @click="editChatGreeting"
                :class="{ disabled: !projectSettingsLoaded || !user?.email_verified || currentService.service.active < 0 }"
            ) [Edit]

        .bq-toggle-row
            .bq-toggle-label
                span Freeze Database
                small.bq-toggle-hint When frozen, the database cannot be modified by non-admin users.
            Toggle(
                :active="currentService.service.freeze_database"
                :disabled="currentService.service.active < 0 || updatingValue.freeze_database"
                @click="changeFreezeDatabase(!currentService.service.freeze_database)"
            )

        .bq-toggle-row
            .bq-toggle-label
                span Allow Signup
                small.bq-toggle-hint When allowed, users can create account to your BunnyQuery chat.
            Toggle(
                :active="!currentService.service.prevent_signup"
                :disabled="currentService.service.active < 0 || updatingValue.prevent_signup"
                @click="changeCreateUserMode(!currentService.service.prevent_signup)"
            )

        //- The access group an uploaded file's records are written at, held in a
        //- record of the project's own database ("bq::settings"), not on the
        //- service record. Sits beside "Allow anonymous users" because the two
        //- decide the same thing together: an anonymous visitor can only ever
        //- read records at the "Public" group.
        //- Disabled until the settings record has been read, so the control can
        //- never show a value it has not actually fetched.
        .bq-row
            .bq-toggle-label(style='min-width: 6rem;')
                span Default access
                small.bq-toggle-hint Access group for the files you upload, and for everything BunnyQuery indexes out of them.
            .bq-ai-select(@click.stop="" style='left: -4px;')
                button.bq-ai-select-btn(type="button" @click.prevent="toggleUploadAccessMenu" :disabled="settingsLocked || updatingValue.uploadAccess || !projectSettingsLoaded" :class="{ open: uploadAccessMenuOpen }")
                    span.bq-ai-select-value
                        span {{ uploadAccessLabel }}
                    span.bq-ai-caret ▾
                select.bq-ai-select-native(
                    v-if="isMobile"
                    :value="uploadAccessSetting"
                    :disabled="settingsLocked || updatingValue.uploadAccess || !projectSettingsLoaded"
                    @change="selectUploadAccessGroup($event.target.value)"
                    aria-label="Default access"
                )
                    option(v-for="o in uploadAccessOptions" :key="o.value" :value="o.value") {{ o.label }}
                .bq-ai-options(v-if="!isMobile && uploadAccessMenuOpen")
                    button.bq-ai-option(
                        v-for="o in uploadAccessOptions"
                        :key="o.value"
                        type="button"
                        @mousedown.prevent
                        @click="selectUploadAccessGroup(o.value)"
                        :class="{ active: uploadAccessSetting === o.value }"
                    )
                        span {{ o.label }}

        //- Whether the chat's answers may reach the open web (Claude web_fetch,
        //- OpenAI web_search). Held in the same "bq::settings" record as the two
        //- settings above (its own `web_access` key) and read by the chat engine
        //- when it builds a chat request, so this project's chat here, its hosted
        //- widget page and any embed that does not pin the `webAccess` init
        //- option all follow it without a re-push. Off by default: answers then
        //- come from this project's files and database alone.
        .bq-toggle-row
            .bq-toggle-label
                span Web access for answers
                small.bq-toggle-hint Off: answers come only from this project's files and database. On: the AI may also search the web.
            Toggle(
                :active="webAccessStored"
                :disabled="settingsLocked || currentService.service.active < 0 || updatingValue.webAccess || !projectSettingsLoaded"
                @click="changeWebAccess(!webAccessStored)"
            )

        //- Whether a file this account already uploaded (same name, same size)
        //- is skipped instead of uploaded again. Same "bq::settings" record, its
        //- own `skip_duplicate_files` key, read by both upload paths (the Files
        //- page queue and the chat's attachments) and by the widget. ON when the
        //- key is absent: a project that never opens this skips duplicates.
        .bq-toggle-row
            .bq-toggle-label
                span Skip duplicate files
                small.bq-toggle-hint On: a file with the same name and size that this account already uploaded is skipped. Off: every file is uploaded again.
            Toggle(
                :active="skipDuplicatesStored"
                :disabled="settingsLocked || currentService.service.active < 0 || updatingValue.skipDuplicates || !projectSettingsLoaded"
                @click="changeSkipDuplicates(!skipDuplicatesStored)"
            )

        //- Whether the embeddable chat opens on the login page or straight into
        //- the chat. Read by the widget from getConnectionInfo().conf.
        //- Deliberately NOT prevent_anonymous: that flag governs anonymous record
        //- WRITES at the skapi layer, which the BunnyQuery MCP refuses outright
        //- regardless, and it has never gated reading public records.
        .bq-toggle-row
            .bq-toggle-label
                span Require login
                small.bq-toggle-hint(v-if="anonymousKeyWarning") {{ anonymousKeyWarning }}
                small.bq-toggle-hint(v-else) When off, visitors can use your chat without an account. They can only read your public records, and can never write.
            Toggle(
                :active="requireLogin"
                :disabled="currentService.service.active < 0 || updatingValue.require_login"
                @click="changeRequireLogin(!requireLogin)"
            )
        //- .bq-toggle-row
        //-     .bq-toggle-label
        //-         span Allow Signup
        //-         small.bq-toggle-hint When disallowed, only the administrator can create accounts.
        //-     Toggle(
        //-         :active="!currentService.service.prevent_signup"
        //-         :disabled="currentService.service.active < 0 || updatingValue.prevent_signup"
        //-         @click="changeCreateUserMode(!currentService.service.prevent_signup)"
        //-     )
    //- delete
    .bq-section(v-if="canDeleteService" style="text-align:right")
        router-link.bq-link.bq-danger(
            :to="'/delete-service/' + currentService.id"
            :class="{ disabled: !user?.email_verified || currentService.service.active == 0 }"
        ) [Delete Project]

    //- modals
    Modal(:open="modifyMode.name" @close="() => { if (!updatingValue.name) modifyMode.name = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.name = false" :class="{ disabled: updatingValue.name }") &times;
            form.bq-modal-step(@submit.prevent="changeName")
                h2 Change Service Name
                p.bq-modal-desc Enter a new name for the service (max 40 characters).
                input.bq-modal-input(
                    type="text"
                    ref="focus_name"
                    placeholder="Max 256 characters"
                    maxlength="256"
                    :value="inputName"
                    @input="e => inputName = e.target.value"
                    :disabled="updatingValue.name"
                    required
                )
                button.btn(
                    type="submit"
                    :class="{ 'bq-btn--loading': updatingValue.name }"
                )
                    span.bq-loader(v-if="updatingValue.name")
                    template(v-else) Save

    Modal(:open="modifyMode.cors" @close="() => { if (!updatingValue.cors) modifyMode.cors = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.cors = false" :class="{ disabled: updatingValue.cors }") &times;
            form.bq-modal-step(@submit.prevent="changeCors")
                h2 CORS
                p.bq-modal-desc When set, this service will only accept requests from the specified origins.
                p.bq-modal-desc Comma separated origins. Leave empty to allow every origin.
                input#modifyCors.bq-modal-input(
                    ref="focus_cors"
                    :disabled="updatingValue.cors || null"
                    type="text"
                    placeholder="https://your.domain.com, ..."
                    :value="inputCors"
                    @input="e => { e.target.setCustomValidity(''); inputCors = e.target.value; }"
                )
                button.btn(
                    type="submit"
                    :class="{ 'bq-btn--loading': updatingValue.cors }"
                )
                    span.bq-loader(v-if="updatingValue.cors")
                    template(v-else) Save

    Modal(:open="modifyMode.description" @close="() => { if (!updatingValue.description) modifyMode.description = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.description = false" :class="{ disabled: updatingValue.description }") &times;
            form.bq-modal-step(@submit.prevent="changeDescription")
                h2 Base Prompt
                p.bq-modal-desc Add a short description or base prompt for your project. This can be used to provide default context to AI.
                textarea.bq-modal-textarea(
                    ref="focus_description"
                    :disabled="updatingValue.description || null"
                    placeholder="Describe your project..."
                    maxlength="1000"
                    rows="4"
                    :value="inputDescription"
                    @input="e => inputDescription = e.target.value"
                )
                button.btn(
                    type="submit"
                    :class="{ 'bq-btn--loading': updatingValue.description }"
                )
                    span.bq-loader(v-if="updatingValue.description")
                    template(v-else) Save

    Modal(:open="modifyMode.chatGreeting" @close="() => { if (!updatingValue.chatGreeting) modifyMode.chatGreeting = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.chatGreeting = false" :class="{ disabled: updatingValue.chatGreeting }") &times;
            form.bq-modal-step(@submit.prevent="changeChatGreeting")
                h2 Chat Intro
                p.bq-modal-desc The first message your chat opens with, in your own words. It replaces the default line for everyone who opens this project's chat, including the embedded widget. The assistant is also told this is what it opened with, so it can answer questions about it.
                p.bq-modal-desc Leave it empty to go back to the default intro.
                textarea.bq-modal-textarea(
                    ref="focus_chatGreeting"
                    :disabled="updatingValue.chatGreeting || null"
                    placeholder="Hi! Start by attaching the files related to your project..."
                    :maxlength="CHAT_GREETING_MAX_LENGTH"
                    rows="4"
                    :value="inputChatGreeting"
                    @input="e => inputChatGreeting = e.target.value"
                )
                button.btn(
                    type="submit"
                    :class="{ 'bq-btn--loading': updatingValue.chatGreeting }"
                )
                    span.bq-loader(v-if="updatingValue.chatGreeting")
                    template(v-else) Save

    //- Revert is a write over the live page, so it asks first and says which
    //- version goes and which one comes back.
    Modal(:open="modifyMode.widgetRevert" @close="() => { if (!updatingValue.widgetRevert) modifyMode.widgetRevert = false }")
        .bq-modal-delete
            .bq-modal-delete-header
                span.material-symbols-outlined.bq-modal-delete-icon(translate="no") history
                span Revert Chat Widget
            .bq-modal-delete-body
                p(translate="no") {{ widgetRevertQuestion }}
                p.bq-modal-delete-warn The page published now is kept as the new saved page, so you can revert again to bring it back.
            .bq-modal-delete-footer
                template(v-if="updatingValue.widgetRevert")
                    span.bq-loader.bq-loader--right Reverting
                template(v-else)
                    button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                        @click="modifyMode.widgetRevert = false"
                    ) Cancel
                    button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                        @click="revertWidget"
                    ) Revert

    Modal(:open="modifyMode.widgetOverwrite" @close="() => { modifyMode.widgetOverwrite = false }")
        .bq-modal-delete
            .bq-modal-delete-header
                span.material-symbols-outlined.bq-modal-delete-icon(translate="no") warning
                span Replace the Published Page?
            .bq-modal-delete-body
                p(translate="no") The page published at {{ widgetUrlLabel }} is not the BunnyQuery chat page. It looks like a site you published through web hosting.
                p.bq-modal-delete-warn Updating replaces its index.html with the chat page. Your other files stay. The current index.html is saved first, and Revert brings it back.
            .bq-modal-delete-footer
                button.bq-modal-delete-btn.bq-modal-delete-btn--cancel(
                    @click="modifyMode.widgetOverwrite = false"
                ) Cancel
                button.bq-modal-delete-btn.bq-modal-delete-btn--delete(
                    @click="confirmOverwriteWidget"
                ) Replace page

    Modal(:open="modifyMode.aiApiKey" @close="() => { if (!updatingValue.aiApiKey) modifyMode.aiApiKey = false }")
        .bq-modal-wrap
            .bq-modal-close(@click="modifyMode.aiApiKey = false" :class="{ disabled: updatingValue.aiApiKey }") &times;
            form.bq-modal-step(@submit.prevent="saveAiApiKey")
                h2 API Key
                p.bq-modal-desc Enter your {{ aiPlatform === 'claude' ? 'Claude' : 'OpenAI' }} API key.
                textarea.bq-modal-textarea(
                    ref="focus_aiApiKey"
                    :disabled="updatingValue.aiApiKey || null"
                    placeholder="sk-..."
                    :value="inputAiApiKey"
                    @input="e => inputAiApiKey = e.target.value"
                    rows="3"
                )
                button.btn(
                    type="submit"
                    :class="{ 'bq-btn--loading': updatingValue.aiApiKey }"
                )
                    span.bq-loader(v-if="updatingValue.aiApiKey")
                    template(v-else) Save
</template>

<script setup lang="ts">
import { useRoute, useRouter } from "vue-router";
import { computed, nextTick, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import { currentService, serviceClientSecrets, aiModelCache, aiApiKeyCache, aiApiKeyInflight, saveAiApiKeyPrivately, loadAiApiKeyPrivately } from "@/views/project-list";
import { SkapiError } from "skapi-js";
import {
    DEFAULT_CLAUDE_MODEL, DEFAULT_OPENAI_MODEL,
    parseAiAgentValue, buildAiAgentValue as engineBuildAiAgentValue,
    getModelContextWindow, registerModelContextWindows, DEFAULT_CONTEXT_WINDOW,
    getMaxOutputTokens, TOOL_AND_RESPONSE_BUFFER,
} from "@/code/ai_agent";
import { loadModelCatalogue, apiKeyRejected, invalidateApiKeyVerdict } from "@/code/ai_models";
import { dateFormat } from "@/code/utils";
import { skapi } from "@/main";
import { user } from "@/code/user";
import Modal from "@/components/modal.vue";
import Toggle from "@/components/toggle.vue";
import { removeFullScreenLoader } from "@/components/jsComponents";
import chatgptLogo from "@/assets/img/logo/gpt-logo-low.png";
import claudeLogo from "@/assets/img/logo/claude-logo-low.png";
import { MCP_BASE_URL } from "@/code/mcp_oauth";
import {
    readHostedWidget, readWidgetBackup, fetchLatestWidgetTemplate,
    updateHostedWidget, revertHostedWidget,
    type WidgetWriteResult,
} from "@/code/widget_update";
import { hostDomain, aiClientSecretGrp } from "@/code/service";
import { isServiceRunning, isServiceContained } from "@/code/service-spec";
import { STORED_LIMIT_LABEL } from "@/code/plan-state";
import { PLAN_DOCS, bandwidthMeterNote, emailSendsMeterNote, emailStorageMeterNote, hardStopNote, planCtaLabel, suspendedLimitRows } from "@/code/plan-copy";
import { regionLabel } from "@/code/regions";
import {
    UPLOAD_ACCESS_OPTIONS, UPLOAD_ACCESS_LABELS, DEFAULT_UPLOAD_ACCESS_GROUP,
    CHAT_GREETING_MAX_LENGTH, normalizeChatGreeting, chatGreetingFrom,
    normalizeUploadAccessGroup, projectAccessSetting,
    PROJECT_SETTINGS_TABLE, PROJECT_SETTINGS_UNIQUE_ID, PROJECT_SETTINGS_ACCESS_GROUP,
    readyProjectSettings, patchProjectSettings, cachedProjectSettings,
    type ProjectAccessSetting, type ProjectSettingsData,
} from "@/code/access_group";
// Skip duplicate files: the switch's key and its default (on when absent),
// shared with both upload paths so the page can never show a different default
// than the one the uploads apply.
import { SKIP_DUPLICATE_FILES_KEY, skipDuplicateFilesFrom } from "./duplicates";

const router = useRouter();

/**
 * Whether this project is in a state where its settings may be changed.
 *
 * The three settings cards used to gate on `service.will_terminate`, a DATE
 * derived from the Stripe subscription. That date is absent on a suspended
 * project whose row was never stamped with `suspended_at`, and on every
 * project for as long as the background Stripe fetch is in flight, so a
 * suspended project's controls stayed fully live and editable. `service.active`
 * is the state itself and is on the row from the first render, so gate on it:
 * 1 is running, and 0/-1/-2 and below -100 (disabled, suspended, deleted, contained) all
 * mean the project cannot be used until the owner resumes the plan or support
 * steps in.
 *
 * Note the recovery path is deliberately NOT behind this: "Resume Plan" lives
 * in the Plan & Usage card, which carries no disabled binding.
 */
const projectRunning = computed(() =>
    isServiceRunning(currentService.value?.service?.active)
);

/** The shared condition for every settings card and control on this page. */
const settingsLocked = computed(
    () => !user?.email_verified || !projectRunning.value
);

/** A suspended project's over-limit rows, for the Plan & Usage card. */
const suspendRows = computed(() => suspendedLimitRows(currentService.value));

/** The one line under the Email sends and Email Storage meters. */
const sendsNote = computed(() => emailSendsMeterNote(currentService.value));
const storageNote = computed(() => emailStorageMeterNote(currentService.value));
const route = useRoute();

// The region is picked by city when a project is created, so name it here too
// rather than leaving the reader to decode "eu-west-3". Falls back to the bare
// code for a region the catalogue does not know.
const regionText = (region: string): string => {
    let label = regionLabel(region);
    return label && label !== region ? `${region} (${label})` : region || "";
};

let inputName = "";
let inputCors = "";
let inputDescription = "";
let modifyMode = reactive({
    name: false,
    cors: false,
    description: false,
    aiApiKey: false,
    chatGreeting: false,
    widgetRevert: false,
    widgetOverwrite: false,
});
// Shown under the "Allow anonymous users" row when the flag saved but the AI
// key's access group did not follow it, which leaves the toggle telling the
// owner something the backend does not agree with.
let anonymousKeyWarning = ref("");

let updatingValue = reactive({
    name: false,
    cors: false,
    description: false,
    prevent_signup: false,
    enableDisable: false,
    prevent_inquiry: false,
    freeze_database: false,
    require_login: false,
    aiApiKey: false,
    widget: false,
    widgetRevert: false,
    uploadAccess: false,
    chatGreeting: false,
    webAccess: false,
    skipDuplicates: false,
});

/* ─── hosted chat widget (Advanced > Chat Widget) ─── */
// The version the project is serving right now, scraped from its hosted
// index.html, and the version the published template would install. Both are
// null until the probe lands; `widgetProbed` separates "still looking" from
// "looked, and there is no page".
let hostedWidgetVersion = ref<string | null>(null);
let hostedWidgetPresent = ref(false);
// null until probed; false = index.html exists but is not a chat page (see isWidgetPage).
let hostedIsWidget = ref<boolean | null>(null);
let latestWidgetVersion = ref<string | null>(null);
let widgetProbed = ref(false);
let widgetError = ref("");

// The page saved by the last update, which is what [Revert] restores. The two
// fingerprints answer whether restoring it would change anything: an update
// interrupted between its two writes leaves the saved page identical to the
// published one, and a revert to the same file is not an action worth offering.
let hostedWidgetFingerprint = ref<string | null>(null);
let widgetBackupSaved = ref(false);
let widgetBackupVersion = ref<string | null>(null);
let widgetBackupFingerprint = ref<string | null>(null);

let widgetVersionLabel = computed(() => {
    if (!widgetProbed.value) return "Checking...";
    if (!hostedWidgetPresent.value) return "No page published yet";

    const latest = latestWidgetVersion.value;
    // A site the owner published through web hosting, not the chat page: say so
    // instead of "Unknown version", and Update asks before replacing it.
    if (hostedIsWidget.value === false) return latest ? `Published page is not the chat page (latest v${latest})` : "Published page is not the chat page";

    const cur = hostedWidgetVersion.value;
    if (!cur) return latest ? `Unknown version (latest v${latest})` : "Unknown version";
    if (!latest) return `v${cur}`;
    return cur === latest ? `v${cur} (up to date)` : `v${cur} (latest v${latest})`;
});

// Whether the published page already IS the latest template. It only words the
// version line ("up to date"); it does not hold [Update] back (owner, 2026-10-19):
// the same version can still be worth publishing again, for a page that was
// edited by hand, a template rebuilt under the same version, or a publish that
// did not land in full. It takes both versions being known and equal: a project
// with no page yet, or an unknown version on either side (an unreadable page, an
// unreachable template), is not a match.
let widgetUpToDate = computed(
    () =>
        widgetProbed.value &&
        hostedWidgetPresent.value &&
        !!hostedWidgetVersion.value &&
        !!latestWidgetVersion.value &&
        hostedWidgetVersion.value === latestWidgetVersion.value,
);

// The update writes index.html into the project's subdomain folder, so it needs
// a settled subdomain. `pending.cdn` is excluded too: refreshCDN would refuse
// while a previous invalidation is still in flight, and the update ends in one.
//
// `widgetProbed` gates it as well, so the button is dead while the row still
// reads "Checking...": clicking mid-probe would publish against versions nobody
// has seen yet, and the answer arriving a moment later could well have said the
// page was already current. That gate is only safe because every read in
// widget_update.ts is bounded (FETCH_TIMEOUT_MS) -- an unbounded probe would
// hang here and never give the button back. A probe that fails still lands,
// leaving the update available with the reason shown in the row.
let canUpdateWidget = computed(() => {
    const sd = currentService.value?.service?.subdomain;
    return !!(
        user?.email_verified &&
        sd &&
        !"+*!".includes(sd[0]) &&
        currentService.value?.service?.active >= 0 &&
        !currentService.value?.pending?.cdn &&
        !updatingValue.widget &&
        !updatingValue.widgetRevert &&
        widgetProbed.value
    );
});

let widgetBackupDiffers = computed(
    () =>
        widgetBackupSaved.value &&
        (!hostedWidgetPresent.value ||
            widgetBackupFingerprint.value !== hostedWidgetFingerprint.value),
);

// Same conditions as the update, for the same reasons: the revert writes
// index.html too and ends in the same CDN refresh. It needs a saved page that
// differs from the published one.
let canRevertWidget = computed(() => {
    const sd = currentService.value?.service?.subdomain;
    return !!(
        user?.email_verified &&
        sd &&
        !"+*!".includes(sd[0]) &&
        currentService.value?.service?.active >= 0 &&
        !currentService.value?.pending?.cdn &&
        !updatingValue.widget &&
        !updatingValue.widgetRevert &&
        widgetProbed.value &&
        widgetBackupDiffers.value
    );
});

let widgetBackupName = computed(() =>
    widgetBackupVersion.value ? `v${widgetBackupVersion.value}` : "unknown version",
);

// Empty until there is a saved page, so the row gains a line only when there is
// something to say. While the CDN refresh from the last write is still running
// both actions are held, which is otherwise a dead [Revert] with no reason
// given at the exact moment someone is most likely to want it.
let widgetBackupLabel = computed(() => {
    if (!widgetProbed.value || !widgetBackupSaved.value) return "";
    if (!widgetBackupDiffers.value) return "Saved page is the same as the published one";
    const saved = `Saved page to revert to: ${widgetBackupName.value}`;
    return currentService.value?.pending?.cdn
        ? `${saved}. Available once the CDN refresh finishes.`
        : saved;
});

let widgetRevertQuestion = computed(() => {
    const cur = hostedWidgetVersion.value ? `v${hostedWidgetVersion.value}` : "";
    return cur
        ? `Replace the published chat page (${cur}) with the saved page (${widgetBackupName.value})?`
        : `Replace the published chat page with the saved page (${widgetBackupName.value})?`;
});

let probeWidgetVersions = async () => {
    widgetError.value = "";
    // Both reads are independent and started together; a failure to reach the
    // published template must not hide the version the project is actually
    // serving, which is the part this row exists to show. Each settles into its
    // own value rather than rejecting, so neither can cancel the other.
    const hostedPromise = readHostedWidget(currentService.value).then(
        (r) => ({ ok: true, r }),
        (e) => ({ ok: false, e }),
    );
    const latestPromise = fetchLatestWidgetTemplate().then(
        (r) => ({ ok: true, r }),
        (e) => ({ ok: false, e }),
    );
    const backupPromise = readWidgetBackup(currentService.value).then(
        (r) => ({ ok: true, r }),
        (e) => ({ ok: false, e }),
    );

    try {
        const hosted: any = await hostedPromise;
        if (hosted.ok) {
            hostedWidgetPresent.value = hosted.r.hosted;
            hostedWidgetVersion.value = hosted.r.version;
            hostedWidgetFingerprint.value = hosted.r.fingerprint;
            hostedIsWidget.value = hosted.r.widget;
        } else {
            widgetError.value = errText(hosted.e);
        }

        // A backup that could not be read is left as "none saved", quietly: it
        // only decides whether [Revert] is offered, and the row's one error line
        // belongs to the published page. The revert reads the file again itself
        // and reports its own failure.
        const backup: any = await backupPromise;
        if (backup.ok) {
            widgetBackupSaved.value = backup.r.saved;
            widgetBackupVersion.value = backup.r.version;
            widgetBackupFingerprint.value = backup.r.fingerprint;
        }

        // "Latest" is the version the PUBLISHED template pins, and nothing else.
        // Not what npm has: the template's pin only moves when someone runs
        // infra/_bunnyquery_widget_update.py --apply, and that lag is exactly
        // what this row is here to make visible. A number resolved from the
        // registry would read as current whether or not the deploy ever ran.
        const latest: any = await latestPromise;
        if (latest.ok) latestWidgetVersion.value = latest.r.version;
    } finally {
        widgetProbed.value = true;
    }
};

// The update writes index.html. When the file there is not a chat page (a site
// the owner published through web hosting, which this would replace), ask first;
// the saved copy and [Revert] still bring it back, but the owner should know
// before it goes.
let updateWidget = () => {
    if (!canUpdateWidget.value) return;
    if (hostedWidgetPresent.value && hostedIsWidget.value === false) {
        modifyMode.widgetOverwrite = true;
        return;
    }
    void runWidgetUpdate();
};

let confirmOverwriteWidget = () => {
    modifyMode.widgetOverwrite = false;
    void runWidgetUpdate();
};

let runWidgetUpdate = async () => {
    if (!canUpdateWidget.value) return;

    updatingValue.widget = true;
    widgetError.value = "";
    try {
        const res = await updateHostedWidget(currentService.value);
        applyWidgetWrite(res);
        if (res.version) latestWidgetVersion.value = res.version;
        if (!res.refreshed) {
            // The bytes are in the bucket; only the invalidation did not queue.
            // Say so rather than reporting a clean success the visitor will not
            // see for up to a day.
            widgetError.value = "Page updated. The CDN refresh did not queue, retry it from Hosting.";
        }
    } catch (err: any) {
        widgetError.value = errText(err);
    } finally {
        updatingValue.widget = false;
    }
};

// What the row shows after either write, taken from what was written rather
// than read back: both files were just put in the bucket from these bytes.
let applyWidgetWrite = (res: WidgetWriteResult) => {
    hostedWidgetPresent.value = true;
    hostedIsWidget.value = true;
    hostedWidgetVersion.value = res.hosted.version;
    hostedWidgetFingerprint.value = res.hosted.fingerprint;
    // null = the backup file was not touched, so what is known about it stands.
    if (res.backup) {
        widgetBackupSaved.value = true;
        widgetBackupVersion.value = res.backup.version;
        widgetBackupFingerprint.value = res.backup.fingerprint;
    }
};

let askRevertWidget = () => {
    if (!canRevertWidget.value) return;
    modifyMode.widgetRevert = true;
};

let revertWidget = async () => {
    if (!canRevertWidget.value) {
        modifyMode.widgetRevert = false;
        return;
    }

    updatingValue.widgetRevert = true;
    widgetError.value = "";
    try {
        const res = await revertHostedWidget(currentService.value);
        applyWidgetWrite(res);
        if (!res.refreshed) {
            widgetError.value = "Page reverted. The CDN refresh did not queue, retry it from Hosting.";
        }
    } catch (err: any) {
        widgetError.value = errText(err);
    } finally {
        updatingValue.widgetRevert = false;
        modifyMode.widgetRevert = false;
    }
};

let errText = (err: any) =>
    (typeof err === "string" ? err : err?.message) || "Something went wrong.";

/* ─── the project's public chat link (the card at the top of the page) ─── */
// A subdomain carries a one-character status flag while it is in transit
// ('+new'), being released ('*old') or held ('!old'). The flag is bookkeeping,
// not part of the address, so it is stripped before the link is drawn -- the
// buried row this card replaced printed it verbatim and showed people a
// "+myproject.bunnyquery.com" they could neither open nor share.
let widgetSubdomain = computed(() => {
    const sd = currentService.value?.service?.subdomain || "";
    if (!sd) return "";
    return "+*!".includes(sd[0]) ? sd.slice(1) : sd;
});

let widgetUrlLabel = computed(() =>
    widgetSubdomain.value ? `${widgetSubdomain.value}.${hostDomain}` : "",
);

let widgetUrl = computed(() =>
    widgetUrlLabel.value ? `https://${widgetUrlLabel.value}` : "",
);

// Whether the address is serving right now. A flagged subdomain still has a
// readable address worth copying, but opening it would land on nothing yet, so
// only the live case gets a working [Open].
let widgetLinkLive = computed(() => {
    const sd = currentService.value?.service?.subdomain || "";
    return !!sd && !"+*!".includes(sd[0]);
});

let widgetLinkNote = computed(() => {
    const sd = currentService.value?.service?.subdomain || "";
    if (!sd) return "";
    if (sd[0] === "+") return "This address is still being set up. It goes live in a few minutes.";
    if (sd[0] === "*") return "This address is being released and will stop working.";
    if (sd[0] === "!") return "This address is on hold.";
    // A settled address with nothing published behind it answers a visitor with
    // a 404, so say so here rather than letting someone share a dead link. Only
    // once the probe has actually landed AND came back clean: a probe that could
    // not reach the page leaves `hostedWidgetPresent` false too, and reporting
    // that as "nothing published" would be a lie about a working widget.
    if (widgetProbed.value && !widgetError.value && !hostedWidgetPresent.value)
        return "No chat page is published at this address yet. Publish it from Advanced > Chat Widget.";
    return "";
});

let widgetLinkCopied = ref(false);
let widgetCopyTimer: ReturnType<typeof setTimeout> | null = null;

let copyWidgetLink = async () => {
    const url = widgetUrl.value;
    if (!url) return;

    try {
        await navigator.clipboard.writeText(url);
    } catch {
        // navigator.clipboard is absent over plain http and inside some embedded
        // browsers, and rejects when the document is not focused. The hidden
        // textarea still copies in all of those.
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        ta.remove();
    }

    widgetLinkCopied.value = true;
    if (widgetCopyTimer) clearTimeout(widgetCopyTimer);
    widgetCopyTimer = setTimeout(() => {
        widgetLinkCopied.value = false;
    }, 1600);
};
let focus_name = ref();
let focus_cors = ref();
let focus_description = ref();
let focus_chatGreeting = ref();
let focus_aiApiKey = ref();

let aiPlatform = ref('none');
let aiApiKey = ref('');
let inputAiApiKey = '';
let fetchingAiApiKey = ref(false);
let loadingAiApiKey = ref(false);
let aiApiKeyLoadingDots = ref('.');
let aiApiKeyLoadingDotsTimer: ReturnType<typeof setInterval> | null = null;
const startAiApiKeyDots = () => {
    if (aiApiKeyLoadingDotsTimer) return;
    let n = 0;
    aiApiKeyLoadingDots.value = '.';
    aiApiKeyLoadingDotsTimer = setInterval(() => {
        n = (n + 1) % 3;
        aiApiKeyLoadingDots.value = '.'.repeat(n + 1);
    }, 350);
};
const stopAiApiKeyDots = () => {
    if (aiApiKeyLoadingDotsTimer) {
        clearInterval(aiApiKeyLoadingDotsTimer);
        aiApiKeyLoadingDotsTimer = null;
    }
};
let aiPlatformMenuOpen = ref(false);
let isMobile = ref(false);

let aiModels = ref<any[]>([]);
let fetchingAiModels = ref(false);
let aiModelsError = ref(false);
let selectedModel = ref('');
let modelMenuOpen = ref(false);
let aiPlatformFetchToken = 0;

type AiPlatform = 'none' | 'claude' | 'openai';

// ChatGPT leads the list so it reads as the house default; Claude follows.
// Keep this order in sync with agent.vue / dbfile.vue's platformOptions.
const aiPlatformOptions: { value: AiPlatform; label: string; logo?: string }[] = [
    { value: 'none', label: 'None' },
    { value: 'openai', label: 'ChatGPT', logo: chatgptLogo },
    { value: 'claude', label: 'Claude', logo: claudeLogo },
];

const selectedAiPlatform = computed(() => {
    return aiPlatformOptions.find(o => o.value === aiPlatform.value) || aiPlatformOptions[0];
});

const toggleAiPlatformMenu = () => {
    if (isMobile.value) return;
    modelMenuOpen.value = false;
    aiPlatformMenuOpen.value = !aiPlatformMenuOpen.value;
};

const selectAiPlatform = (value: AiPlatform) => {
    aiPlatformMenuOpen.value = false;
    aiPlatform.value = value;
};

const closeAiPlatformMenu = () => {
    aiPlatformMenuOpen.value = false;
};

const selectedModelLabel = computed(() => {
    if (!selectedModel.value) return 'Select model';
    let m = aiModels.value.find(m => m.id === selectedModel.value);
    return m?.display_name || m?.id || selectedModel.value;
});

const toggleModelMenu = () => {
    if (isMobile.value) return;
    aiPlatformMenuOpen.value = false;
    contextMenuOpen.value = false;
    modelMenuOpen.value = !modelMenuOpen.value;
};

// --- Context window -------------------------------------------------------
// Per-project override of how much context the chat may use. Stored as the
// third segment of `ai_agent` and applied by the engine's getContextWindow.
// Without an override a project runs at DEFAULT_CONTEXT_WINDOW (clamped to the
// model), so "Default" here names a real number rather than a legacy behavior.
const contextMenuOpen = ref(false);
const selectedContextWindow = ref<number | null>(
    parseAiAgentValue(currentService.value?.service?.ai_agent).contextWindow
);

// The presets are cut from the selected model's own window, not from one ladder
// for every model: its full window ("max"), half and a quarter of it (in 25K
// steps), and one small cost-saving step. An entry equal to what "Default" already
// resolves to is not repeated, and no entry leaves less than 64K for input. A 1.05M
// model (gpt-6-luna) is offered 1.05M max, 525K, 250K and 128K; a 400K model
// (gpt-5.4-nano) 200K, 128K and 100K under a 400K default.
const SMALL_CONTEXT_PRESETS = [128000];
const MIN_INPUT_PRESET = 64000;

const fmtTokens = (n: number) => {
    if (n >= 1000000) {
        const m = n / 1000000;
        // 1,050,000 is "1.05M", never "1.1M"; 1,000,000 is "1M"
        return (Math.round(m * 100) / 100).toString() + 'M';
    }
    return Math.round(n / 1000) + 'K';
};

/** The model's hard ceiling: the largest window it can be asked for at all. */
const modelContextCeiling = computed(() => {
    if (aiPlatform.value === 'none') return 0;
    return getModelContextWindow(aiPlatform.value, selectedModel.value || undefined) || 0;
});

/**
 * What "Default" resolves to for this model. Normally DEFAULT_CONTEXT_WINDOW,
 * but clamped for a model whose ceiling is lower than it (claude-opus-4-5 and
 * claude-haiku-4-5 are 200K), so the label never promises more than it delivers.
 */
const effectiveDefaultWindow = computed(() => {
    const ceiling = modelContextCeiling.value;
    return ceiling ? Math.min(DEFAULT_CONTEXT_WINDOW, ceiling) : 0;
});

/**
 * The stored value is the TOTAL window a message is budgeted at (the engine's
 * getContextWindow). What the prompt, history and tool results actually get is
 * that minus the model's output reserve and the tool buffer (getInputTokenBudget),
 * so every option says both numbers: the user is choosing input room, and the
 * output reserve is not theirs to spend.
 */
const inputBudgetFor = (window: number) => {
    if (aiPlatform.value === 'none' || !window) return 0;
    const reserve = getMaxOutputTokens(aiPlatform.value, selectedModel.value || undefined) || 0;
    return Math.max(0, window - reserve - TOOL_AND_RESPONSE_BUFFER);
};
// Every option is named by the INPUT room it gives, because that is what the
// owner is choosing; the output size is the model's own number (see the hint).
const windowLabel = (window: number, tag?: string) =>
    `${fmtTokens(inputBudgetFor(window))}${tag ? ' ' + tag : ''}`;

/** The output size for the selected model: fixed by the model, never by this setting. */
const outputReserveTokens = computed(() => {
    if (aiPlatform.value === 'none' || !selectedModel.value) return 0;
    return getMaxOutputTokens(aiPlatform.value, selectedModel.value) || 0;
});
const contextWindowHint = computed(() => {
    const base = 'Input tokens one message may carry: the prompt, the chat history, documents and tool results.';
    const out = outputReserveTokens.value;
    if (!out) return base + ' The output size is not part of this number and depends only on the model.';
    return `${base} The output size is not part of this number and depends only on the model: up to ${fmtTokens(out)} tokens for ${selectedModel.value}.`;
});

// Never offer a window larger than the model actually has: the request would be
// rejected by the provider, and the point of the control is to spend the
// model's context, not to invent more of it. The ceiling is the engine's row for
// the model; a model the engine has no row for falls to the platform default and
// is offered only the small steps, which is what happens when the site runs an
// engine older than its catalogue.
const contextWindowOptions = computed(() => {
    const max = modelContextCeiling.value;
    const dflt = effectiveDefaultWindow.value;
    const opts: Array<{ label: string; value: number | null }> = [
        { label: dflt ? `Default (${windowLabel(dflt)})` : 'Default', value: null },
    ];
    if (!max) return opts;
    const step25 = (n: number) => Math.floor(n / 25000) * 25000;
    const candidates = [max, step25(max / 2), step25(max / 4), ...SMALL_CONTEXT_PRESETS]
        .filter((n) => n > 0 && n <= max && n !== dflt && inputBudgetFor(n) >= MIN_INPUT_PRESET);
    const seen = new Set<number>();
    for (const n of candidates.sort((a, b) => b - a)) {
        if (seen.has(n)) continue;
        seen.add(n);
        opts.push({ label: windowLabel(n, n === max ? 'max' : undefined), value: n });
    }
    return opts;
});

const selectedContextLabel = computed(() => {
    const current = selectedContextWindow.value;
    if (!current) return contextWindowOptions.value[0].label;
    const max = modelContextCeiling.value;
    return windowLabel(current, max && current === max ? 'max' : undefined);
});

const toggleContextMenu = () => {
    if (isMobile.value) return;
    aiPlatformMenuOpen.value = false;
    modelMenuOpen.value = false;
    contextMenuOpen.value = !contextMenuOpen.value;
};

const closeContextMenu = () => {
    contextMenuOpen.value = false;
};

const selectContextWindow = async (raw: number | string | null) => {
    contextMenuOpen.value = false;
    const parsed = raw === null || raw === '' ? null : Number(raw);
    const next = parsed && Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : null;
    const previous = selectedContextWindow.value;
    selectedContextWindow.value = next;
    try {
        await currentService.value.setServiceOption({
            ai_agent: engineBuildAiAgentValue(aiPlatform.value, selectedModel.value, next),
        });
    } catch (err) {
        selectedContextWindow.value = previous;
        throw err;
    }
};

const selectModel = async (modelId: string) => {
    modelMenuOpen.value = false;
    selectedModel.value = modelId;
    // A model change puts the window back to that model's own default (the engine's
    // DEFAULT_CONTEXT_WINDOW clamped to the model, stored as "no override"). An
    // override chosen under the previous model was sized for that model's window
    // and output size; carrying it over would silently mean something else here.
    selectedContextWindow.value = null;
    await currentService.value.setServiceOption({
        ai_agent: engineBuildAiAgentValue(aiPlatform.value, modelId, null),
    });
};

const closeModelMenu = () => {
    modelMenuOpen.value = false;
    contextMenuOpen.value = false;
};

const syncMobile = () => {
    isMobile.value = window.matchMedia('(max-width: 600px)').matches;
    if (isMobile.value) {
        aiPlatformMenuOpen.value = false;
        modelMenuOpen.value = false;
        contextMenuOpen.value = false;
    }
};



async function fetchAiModels(platform: 'claude' | 'openai', token: number) {
    let savedAgent = currentService.value.service.ai_agent || '';
    let savedModel = savedAgent.includes('#') ? savedAgent.split('#')[1] : '';

    fetchingAiModels.value = true;
    aiModelsError.value = false;

    const platformDefault = platform === 'claude' ? DEFAULT_CLAUDE_MODEL : DEFAULT_OPENAI_MODEL;

    // Apply a fetched-or-cached model list and reconcile the saved/selected
    // model. If the saved model is missing from the list, fall back to the
    // platform default (or first available) and persist the change.
    const applyModels = async (models: any[]) => {
        aiModels.value = models;
        // Anthropic's /v1/models reports max_input_tokens per model, which is the
        // authoritative context window. OpenAI's listing has no equivalent, so
        // this is a no-op there and those models fall back to the static table.
        registerModelContextWindows(models);

        if (!models.length) {
            selectedModel.value = '';
            return;
        }

        if (savedModel && models.some((m: any) => m.id === savedModel)) {
            selectedModel.value = savedModel;
            return;
        }

        const fallback =
            (platformDefault && models.some((m: any) => m.id === platformDefault) && platformDefault) ||
            models[0]?.id ||
            '';

        selectedModel.value = fallback;
        if (fallback) {
            await currentService.value.setServiceOption({ ai_agent: `${platform}#${fallback}` });
        } else if (savedModel) {
            await currentService.value.setServiceOption({ ai_agent: platform });
        }
    };

    if (aiModelCache[platform]) {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }

        await applyModels(aiModelCache[platform]);

        if (token === aiPlatformFetchToken) {
            fetchingAiModels.value = false;
        }
        return;
    }

    try {
        let serviceId = currentService.value.id;
        let owner = currentService.value.owner;
        // The list comes from the STATIC catalogue (see @/code/ai_models): the
        // provider's listing call cost seconds through the queue+proxy to fill
        // a dropdown that changes a few times a year.
        let models = await loadModelCatalogue(platform);

        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }

        aiModelCache[platform] = models;
        await applyModels(models);

        // No probe. Key validity is not something this page can learn without
        // spending a provider call, and the call it used to make (a model
        // listing) reported every transport failure as a bad key. The label
        // below reflects the verdict recorded by REAL chat traffic instead, so
        // it only ever says "Invalid API Key" when the provider actually said
        // the key was the problem.
        aiModelsError.value = apiKeyRejected(serviceId, platform);
    } catch {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        aiModels.value = [];
        selectedModel.value = '';
    } finally {
        if (token === aiPlatformFetchToken) {
            fetchingAiModels.value = false;
        }
    }
}

function buildAiAgentValue(platform: string): string {
    return engineBuildAiAgentValue(platform, selectedModel.value, selectedContextWindow.value);
}

watch(aiPlatform, async (platform) => {
    const token = ++aiPlatformFetchToken;

    if (platform === 'none') {
        aiApiKey.value = '';
        aiModels.value = [];
        selectedModel.value = '';
        aiModelsError.value = false;
        fetchingAiApiKey.value = false;
        fetchingAiModels.value = false;
        await currentService.value.setServiceOption({ ai_agent: 'none' });
        return;
    }

    aiApiKey.value = '';
    aiModels.value = [];
    selectedModel.value = '';
    aiModelsError.value = false;
    fetchingAiApiKey.value = true;
    fetchAiModels(platform as 'claude' | 'openai', token);

    let serviceId = currentService.value.id;

    // check lightweight cache first
    let cachedKey = aiApiKeyCache[serviceId]?.[platform as 'claude' | 'openai'];
    if (cachedKey) {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        aiApiKey.value = cachedKey;
        await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        if (token === aiPlatformFetchToken) {
            fetchingAiApiKey.value = false;
        }
        return;
    }

    // check the shared client-secrets pager if it has this key cached already
    let pager = serviceClientSecrets[serviceId];
    if (pager?.list?.[platform]?.client_secret) {
        aiApiKey.value = pager.list[platform].client_secret;
        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [platform]: aiApiKey.value,
        };
        await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        if (token === aiPlatformFetchToken) {
            fetchingAiApiKey.value = false;
        }
        return;
    }

    // The visit-time prefetch (main.vue run) may already be fetching this key —
    // await the shared request so we reuse its result instead of firing a
    // duplicate (same as agent.vue's refreshGate).
    const inflight = aiApiKeyInflight[serviceId + '#' + platform];
    if (inflight) {
        try { await inflight; } catch { /* prefetch is best-effort */ }
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        const prefetched = aiApiKeyCache[serviceId]?.[platform as 'claude' | 'openai'];
        if (prefetched) {
            aiApiKey.value = prefetched;
            await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
            if (token === aiPlatformFetchToken) {
                fetchingAiApiKey.value = false;
            }
            return;
        }
    }

    // fetch from network (filtered by platform). Do not pollute the shared
    // client-secrets pager with a filtered result; cache into aiApiKeyCache.
    try {
        let result = await currentService.value.listClientSecrets(false, platform);
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }

        let match = result.list?.find(cs => cs.id === platform);
        if (match?.key) {
            aiApiKey.value = match.key;
            aiApiKeyCache[serviceId] = {
                ...(aiApiKeyCache[serviceId] || {}),
                [platform]: match.key,
            };
            await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        } else {
            // No key saved for this platform yet. Keep the user's selection so
            // they can add a key via the Edit modal; do not silently revert to 'none'.
            aiApiKey.value = '';
            await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(platform) });
        }
    } catch {
        if (token !== aiPlatformFetchToken || aiPlatform.value !== platform) {
            return;
        }
        aiApiKey.value = '';
    } finally {
        if (token === aiPlatformFetchToken) {
            fetchingAiApiKey.value = false;
        }
    }
});

onMounted(() => {
    removeFullScreenLoader();
    syncMobile();
    const saved = currentService.value.service.ai_agent || '';
    const [platform, model] = saved.includes('#') ? saved.split('#') : [saved, ''];
    if (model) selectedModel.value = model;
    aiPlatform.value = (platform && platform !== 'none') ? platform : 'none';
    window.addEventListener('click', closeAiPlatformMenu);
    window.addEventListener('click', closeModelMenu);
    window.addEventListener('click', closeUploadAccessMenu);
    window.addEventListener('resize', syncMobile);
    // Two network reads the rest of the page does not wait on.
    probeWidgetVersions();
});

onUnmounted(() => {
    window.removeEventListener('click', closeAiPlatformMenu);
    window.removeEventListener('click', closeModelMenu);
    window.removeEventListener('click', closeUploadAccessMenu);
    window.removeEventListener('resize', syncMobile);
    if (widgetCopyTimer) clearTimeout(widgetCopyTimer);
});

let canDeleteService = computed(() => {
    return (
        (currentService.value.service.active < 0 &&
            !isServiceContained(currentService.value.service.active)) ||
        currentService.value.formattedSpecs.currentPlan.label === "Free" ||
        currentService.value.formattedSpecs.currentPlan.label === "Unlimited" ||
        currentService.value.subscription?.will_cancel
    );
});

let editName = () => {
    inputName = currentService.value.service.name;
    modifyMode.name = true;
    nextTick(() => {
        focus_name.value.focus();
    });
};
let changeName = () => {
    if (currentService.value.service.name !== inputName) {
        let regex = /[<>`]/g;
        if (inputName.match(regex)) {
            alert("Angle brackets and backticks are not allowed");
            return;
        }

        let previous = currentService.value.service.name;
        updatingValue.name = true;

        currentService.value
            .setServiceOption({ name: inputName })
            .then(() => {
                updatingValue.name = false;
                currentService.value.service.name = inputName;
                modifyMode.name = false;
            })
            .catch((err) => {
                if (!(err instanceof SkapiError)) throw err;
                updatingValue.name = false;
                currentService.value.service.name = previous;
            });
    } else {
        updatingValue.name = false;
        currentService.value.service.name = inputName;
        modifyMode.name = false;
    }
};

let editCors = () => {
    inputCors =
        currentService.value.service.cors === "*"
            ? ""
            : currentService.value.service.cors;
    modifyMode.cors = true;
    nextTick(() => {
        focus_cors.value.focus();
    });
};
let changeCors = () => {
    updatingValue.cors = true;
    currentService.value
        .setServiceOption({ cors: inputCors })
        .then(() => {
            updatingValue.cors = false;
            modifyMode.cors = false;
        })
        .catch((err) => {
            if (!(err instanceof SkapiError)) throw err;
            updatingValue.cors = false;
            nextTick(() => {
                let modifyCorsEl = document.getElementById("modifyCors") as HTMLInputElement;
                if (modifyCorsEl) {
                    modifyCorsEl.focus();
                    modifyCorsEl.setCustomValidity(err.message);
                    modifyCorsEl.reportValidity();
                }
            });
        });
};

let editDescription = () => {
    inputDescription = currentService.value.service.description || "";
    modifyMode.description = true;
    nextTick(() => {
        focus_description.value?.focus();
    });
};
let changeDescription = () => {
    updatingValue.description = true;
    let desc = inputDescription.trim();
    currentService.value
        .setServiceOption({ description: desc })
        .then(() => {
            updatingValue.description = false;
            currentService.value.service.description = desc;
            modifyMode.description = false;
        })
        .catch((err) => {
            if (!(err instanceof SkapiError)) throw err;
            updatingValue.description = false;
        });
};

let changeCreateUserMode = async (onlyAdmin: boolean) => {
    updatingValue.prevent_signup = true;
    currentService.value
        .setServiceOption({ prevent_signup: onlyAdmin })
        // .catch((err) => {
        //     if (!(err instanceof SkapiError)) throw err;
        //     alert(err.message);
        // })
        .finally(() => {
            updatingValue.prevent_signup = false;
        });
};

let enableDisable = async () => {
    updatingValue.enableDisable = true;
    try {
        if (currentService.value.service.active >= 1)
            await currentService.value.disableService();
        else await currentService.value.enableService();
    } 
    // catch (err) {
    //     if (!(err instanceof SkapiError)) throw err;
    //     window.alert(err.message);
    // } 
    finally {
        updatingValue.enableDisable = false;
    }
};

let changePreventInquiry = async (onlyAdmin: boolean) => {
    updatingValue.prevent_inquiry = true;
    currentService.value
        .setServiceOption({ prevent_inquiry: onlyAdmin })
        // .catch((err) => {
        //     if (!(err instanceof SkapiError)) throw err;
        //     alert(err.message);
        // })
        .finally(() => {
            updatingValue.prevent_inquiry = false;
        });
};

let changeFreezeDatabase = async (onlyAdmin: boolean) => {
    updatingValue.freeze_database = true;
    currentService.value
        .setServiceOption({ freeze_database: onlyAdmin })
        // .catch((err) => {
        //     if (!(err instanceof SkapiError)) throw err;
        //     alert(err.message);
        // })
        .finally(() => {
            updatingValue.freeze_database = false;
        });
};

/* ─── upload access defaults (Advanced > Upload access) ─── */
// The value lives in a record of the project's OWN database ("bq::settings" in
// "__SETTINGS__", public), not on the service record, so it has to be fetched
// before the control can show it and written with postRecord when it changes.
// See @/code/access_group for why it moved.
// The three groups, plus "Ask every time". One control, because "ask" is not a
// group you can also hold a default for: it IS the answer to "which group", and
// the answer is "do not decide here".
const uploadAccessOptions = [
    ...UPLOAD_ACCESS_OPTIONS,
    {
        value: 'ask',
        label: 'Ask every time',
        hint: 'Pick the access for each file as you upload it.',
    },
];
// The engine's store is a plain Map, not a reactive one: it is shared with the
// widget and must not depend on Vue. So the page mirrors the two things the
// template needs into refs of its own, and is the only writer of both.
//
// `uploadAccessStored` is the RAW setting: null when the project has never set
// one, which is a distinction this page (unlike every upload path) needs. See
// selectUploadAccessGroup's no-op guard.
// `projectSettingsLoaded` separates "fetched, and there is none" from "not fetched
// yet". The control stays disabled until it flips, because the sync accessors
// answer with the default before the fetch settles and the guard below would
// then read a value nobody stored as one the user already has.
let uploadAccessStored = ref<ProjectAccessSetting | null>(null);
// Covers BOTH settings held in the bq::settings record: they are read by the one
// fetch in onMounted and settle together, so a second flag could only ever be a
// copy of this one that is wrong while it disagrees.
let projectSettingsLoaded = ref(false);

// The project's custom chat opening line, "" when it has never set one (which
// is what makes the chat use the built-in sentence). Same record and the same
// single fetch as the access group above.
let chatGreetingStored = ref("");
let inputChatGreeting = ref("");

// Whether chat answers may reach the open web. Same record, its own `web_access`
// key, read by the same single fetch. Only the literal true is on: the record is
// public, and a value this page did not write must never read as permission.
// Read straight off the settings data rather than through an engine helper so
// this page compiles against the published engine as well as the next one.
let webAccessStored = ref(false);

onMounted(async () => {
    const service = currentService.value?.id || "";
    if (!service) return;
    // Never rejects: the store settles a failed read as "no record".
    await readyProjectSettings(service);
    // Guard a project switch that happened while this was in flight. This view
    // does remount per project, but the await is long enough to outlive one.
    if ((currentService.value?.id || "") !== service) return;
    uploadAccessStored.value = projectAccessSetting(service);
    projectSettingsLoaded.value = true;
    // One fetch, both settings: cachedProjectSettings is settled by the await
    // above, so this is a map read rather than a second request.
    chatGreetingStored.value = chatGreetingFrom(cachedProjectSettings(service));
    webAccessStored.value = cachedProjectSettings(service)?.web_access === true;
    skipDuplicatesStored.value = skipDuplicateFilesFrom(cachedProjectSettings(service));
});

// Whether a file this account already uploaded (same name and size) is skipped.
// Same record, its own `skip_duplicate_files` key, same single fetch. Unlike the
// web switch its default is ON: only the literal false turns it off, which is
// what skipDuplicateFilesFrom encodes for the upload paths too.
let skipDuplicatesStored = ref(true);

/**
 * Flip the duplicate switch. Same merge-save and the same cache adoption as
 * changeWebAccess, so the next upload on this page follows it without a
 * re-fetch.
 */
let changeSkipDuplicates = async (next: boolean) => {
    const service = currentService.value?.id || "";
    if (!service || !projectSettingsLoaded.value) return;
    if (next === skipDuplicatesStored.value) return;
    updatingValue.skipDuplicates = true;
    try {
        await saveProjectSetting(service, { [SKIP_DUPLICATE_FILES_KEY]: next });
        patchProjectSettings(service, { [SKIP_DUPLICATE_FILES_KEY]: next });
        skipDuplicatesStored.value = next;
    } catch (err) {
        if (err instanceof SkapiError) alert(err.message);
        else throw err;
    } finally {
        updatingValue.skipDuplicates = false;
    }
};

/**
 * Flip the web switch. Saved with the same merge-save as the other two settings
 * (one record, one key each), then adopted into the engine's cache so the chat
 * on this page follows it on its very next turn without a re-fetch.
 */
let changeWebAccess = async (next: boolean) => {
    const service = currentService.value?.id || "";
    if (!service || !projectSettingsLoaded.value) return;
    if (next === webAccessStored.value) return;
    updatingValue.webAccess = true;
    try {
        await saveProjectSetting(service, { web_access: next });
        // patch, not set: the record also holds upload_access_group and
        // chat_greeting.
        patchProjectSettings(service, { web_access: next });
        webAccessStored.value = next;
    } catch (err) {
        // Loud, for the same reason the access-group save is: the toggle would
        // otherwise show a state the stored setting does not have.
        if (err instanceof SkapiError) alert(err.message);
        else throw err;
    } finally {
        updatingValue.webAccess = false;
    }
};

/** What the row shows: the project's own line, or the built-in one named. */
const chatGreetingLabel = computed(
    () => chatGreetingStored.value || "Default intro message",
);

let editChatGreeting = () => {
    // The .disabled class already blocks the pointer; this is the same guard one
    // layer in, so no other caller can open the modal onto a value we have not
    // fetched yet. Same shape as selectUploadAccessGroup's.
    if (!projectSettingsLoaded.value) return;
    inputChatGreeting.value = chatGreetingStored.value;
    modifyMode.chatGreeting = true;
    nextTick(() => {
        focus_chatGreeting.value?.focus();
    });
};

/**
 * Save the custom opening line. An EMPTY box is a valid save, not a no-op: it
 * is how an owner goes back to the built-in sentence, so "" is written to the
 * record and every client reads it as unset.
 */
let changeChatGreeting = async () => {
    const service = currentService.value?.id || "";
    if (!service) return;
    // Normalised with the SAME function the clients read it back through, so
    // what the row shows after saving cannot differ from what the chat opens
    // with (trimmed, blank-line runs collapsed, capped).
    const next = normalizeChatGreeting(inputChatGreeting.value);
    if (next === chatGreetingStored.value) {
        modifyMode.chatGreeting = false;
        return;
    }
    updatingValue.chatGreeting = true;
    try {
        await saveProjectSetting(service, { chat_greeting: next });
        // patch, not set: the record also holds upload_access_group.
        patchProjectSettings(service, { chat_greeting: next });
        chatGreetingStored.value = next;
        modifyMode.chatGreeting = false;
    } catch (err) {
        if (err instanceof SkapiError) alert(err.message);
        else throw err;
    } finally {
        updatingValue.chatGreeting = false;
    }
};

// null when the project has never set one. Shown as the effective default rather
// than as blank, since that is what an upload would actually use.
const uploadAccessSetting = computed(
    () => uploadAccessStored.value || DEFAULT_UPLOAD_ACCESS_GROUP,
);
const uploadAccessLabel = computed(() => {
    const found = uploadAccessOptions.find((o) => o.value === uploadAccessSetting.value);
    return found ? found.label : UPLOAD_ACCESS_LABELS[DEFAULT_UPLOAD_ACCESS_GROUP];
});

const uploadAccessMenuOpen = ref(false);
const toggleUploadAccessMenu = () => {
    if (isMobile.value) return;
    aiPlatformMenuOpen.value = false;
    modelMenuOpen.value = false;
    contextMenuOpen.value = false;
    uploadAccessMenuOpen.value = !uploadAccessMenuOpen.value;
};
const closeUploadAccessMenu = () => {
    uploadAccessMenuOpen.value = false;
};

const selectUploadAccessGroup = async (raw: string) => {
    uploadAccessMenuOpen.value = false;
    const service = currentService.value?.id || "";
    if (!service || !projectSettingsLoaded.value) return;
    const next: ProjectAccessSetting = raw === 'ask' ? 'ask' : normalizeUploadAccessGroup(raw);
    // Compared against the RAW setting, which is null when the project has never
    // set one. uploadAccessSetting DISPLAYS the fallback ('authorized'), so
    // comparing against that made picking the displayed value a no-op: the row
    // read "Signed in users" while the stored setting stayed empty and every
    // client kept falling back, and the owner had no way to correct it.
    if (next === uploadAccessStored.value) return;
    updatingValue.uploadAccess = true;
    try {
        await saveProjectSetting(service, { upload_access_group: next });
        // Adopt what we just wrote rather than re-fetching it: the writer knows
        // the stored value, and leaving the store unsettled would send the next
        // upload back to the network for a value already in hand. patch, not
        // set: the record holds an object and a future setting must survive
        // this save.
        patchProjectSettings(service, { upload_access_group: next });
        uploadAccessStored.value = next;
    } catch (err) {
        // Loud, because the control would otherwise go on showing the value the
        // owner picked while the stored setting says something else, and the
        // thing it decides is who can read their files.
        if (err instanceof SkapiError) alert(err.message);
        else throw err;
    } finally {
        updatingValue.uploadAccess = false;
    }
};

/**
 * Write ONE OR MORE keys into the project's settings record, creating it the
 * first time and updating it after. Shared by every setting stored there (the
 * upload access group, the chat intro line), which is the whole point of the
 * record holding an object.
 *
 * postRecord HAS NO UPSERT. A second save of the same unique_id fails with "is
 * already taken", so without the second half of this the setting could be
 * changed exactly once per project and every later save would throw. Same
 * create-then-settle-as-an-update shape ai_agent's upsertIndexRunRecord uses,
 * for the same reason.
 *
 * The update posts by RECORD_ID and names no table: under the SDK's rule an
 * update that carries no table leaves the record where it is, so the settings
 * record cannot be walked out of the public group by a save that only meant to
 * change a value.
 */
const saveProjectSetting = async (service: string, patch: ProjectSettingsData) => {
    try {
        await (skapi as any).postRecord(patch, {
            service,
            unique_id: PROJECT_SETTINGS_UNIQUE_ID,
            table: { name: PROJECT_SETTINGS_TABLE, access_group: PROJECT_SETTINGS_ACCESS_GROUP },
        });
        return;
    } catch (err: any) {
        // Anything that is NOT the record already existing is a real failure and
        // belongs to the caller: a permission problem must not be retried as an
        // update against a record id we do not have.
        if (String(err?.message || err || '').indexOf('is already taken') === -1) throw err;
    }
    const found: any = await (skapi as any).getRecords({ service, unique_id: PROJECT_SETTINGS_UNIQUE_ID });
    const rec = found?.list?.[0];
    // Taken, but unreadable. Re-throwing the original "is already taken" would
    // name the wrong problem, so say what actually happened.
    if (!rec?.record_id) throw new Error('The project settings record exists but could not be read back, so the setting was not saved.');
    // MERGE, never replace. `data` on this record is a settings OBJECT, and the
    // whole reason it is one record rather than one record per setting is that a
    // second setting is a new KEY here. postRecord replaces `data` wholesale, so
    // posting the patch alone would silently delete every other key the moment
    // one exists. Merged over the record we just read back rather than over the
    // cache: this is the stored state, and it is fresher than anything this tab
    // may have been holding since the page loaded.
    const merged = Object.assign({}, rec.data && typeof rec.data === 'object' ? rec.data : {}, patch);
    await (skapi as any).postRecord(merged, { service, record_id: rec.record_id });
};

/**
 * Unset means TRUE: a project that has never touched this keeps the login wall
 * it has always had. Only an explicit `false` opens the chat, matching
 * aiClientSecretGrp so the flag and the key can never disagree about which way
 * they fail.
 */
const requireLogin = computed(() => currentService.value?.service?.require_login !== false);

let changeRequireLogin = async (requireIt: boolean) => {
    updatingValue.require_login = true;
    try {
        await currentService.value.setServiceOption({ require_login: requireIt });
        // The service flag alone does not open the chat. `client_secret_key_request`
        // refuses an unauthenticated caller whenever the AI key's own access group
        // is non-zero, so the key has to move with the setting or the toggle is
        // cosmetic: anonymous visitors would reach a chat whose every send is
        // rejected with "No access to client secret."
        anonymousKeyWarning.value = "";
        const failed = await syncAiClientSecretGrp();
        if (failed.length) {
            anonymousKeyWarning.value =
                "The setting was saved, but the AI key could not be moved: " + failed.join("; ");
        }
    } finally {
        updatingValue.require_login = false;
    }
};

/**
 * Re-register the project's AI key under the access group the current
 * "Require login" setting implies. `req: 'update'` needs only the id, so
 * the key VALUE is never re-sent (and never has to be read back out of storage).
 *
 * Best effort on purpose: a project with no key configured yet has nothing to
 * move, and that is the common case when the toggle is first switched on. The
 * next saveAiApiKey writes the right group anyway, since it reads the same rule.
 */
let syncAiClientSecretGrp = async (): Promise<string[]> => {
    const grp = aiClientSecretGrp(currentService.value);
    const failed: string[] = [];

    // Which platforms actually HAVE a row in the client-secret table. Asked
    // rather than assumed: `req: 'update'` on a platform that never saved a key
    // answers NOT_EXISTS, and a project whose key lives in the older
    // service-record `client_secret` map has no row here at all. Listing first
    // turns "nothing to move" into a no-op instead of an error the owner sees.
    let existing: string[] = [];
    try {
        const res: any = await currentService.value.listClientSecrets();
        const list = res?.list || [];
        existing = list.map((c: any) => c?.id).filter(Boolean);
    } catch (err: any) {
        // Could not enumerate: fall back to attempting both, which is what this
        // did before, and let the per-platform catch below sort it out.
        existing = ["claude", "openai"];
    }
    // BOTH platforms, not just the selected one. A project that used Claude,
    // switched to OpenAI, then turned the login requirement back on would
    // otherwise leave the Claude key at group 0 forever: still resolvable by an
    // unauthenticated caller, still spending the owner's API budget, with the
    // dashboard reporting anonymous access as disabled. A key that does not
    // exist for a platform simply reports NOT_EXISTS and is skipped.
    for (const platform of ["claude", "openai"]) {
        if (existing.indexOf(platform) === -1) continue;
        try {
            await currentService.value.registerClientSecret({
                id: platform,
                grp,
                req: "update",
            });
        } catch (err: any) {
            // Matched on the CODE, not on `instanceof SkapiError`: this rejects
            // with a plain { code, message } object, so an instanceof test is
            // false for exactly the NOT_EXISTS case it was meant to skip and
            // rethrows it at the toggle, which then reports
            // 'Client secret key "claude" does not exist.' for a project that
            // simply never saved a key for that platform.
            const code = err?.code || "";
            if (code === "NOT_EXISTS") continue;
            // Anything else is a real failure to move the key, and the toggle
            // must not claim success: the flag is saved but the key still
            // refuses (or still accepts) anonymous callers.
            failed.push(platform + ": " + (err?.message || code || "unknown error"));
        }
    }
    return failed;
};

const barColor = (percent: string) => {
    const n = Number(percent.toString().replace("%", ""));
    if (!n) return "";
    // Past 100 on a plan that bills instead of stopping is not a danger, it
    // is a charge: colour it as information, not as a warning.
    if (n > 100 && currentService.value?.formattedSpecs?.currentPlan?.hard_stop === false) return "bq-bar--over";
    if (n >= 80) return "bq-bar--danger";
    if (n >= 50) return "bq-bar--warn";
    return "";
};

// The stacked file pool bar keeps its segment colours whatever the level; the
// TRACK carries the state instead: a warning ring near the ceiling, a danger
// ring on a hard stop plan that has hit it, an informational ring on an overage
// plan past it.
const poolTrackClass = (percent: string) => {
    const n = Number(percent.toString().replace("%", ""));
    if (!n) return "";
    if (n > 100 && currentService.value?.formattedSpecs?.currentPlan?.hard_stop === false) return "bq-bar--over";
    if (n >= 100) return "bq-bar--danger";
    if (n >= 80) return "bq-bar--warn";
    return "";
};

// Usage can exceed the limit on a plan without a hard stop, and a fill wider
// than its track paints over the layout. The number beside the bar still says
// how far over it is.
const barWidth = (percent: string) => {
    const n = Number(percent.toString().replace("%", ""));
    if (!Number.isFinite(n) || n <= 0) return "0%";
    return `${Math.min(n, 100)}%`;
};

let editAiApiKey = async () => {
    if (aiPlatform.value === 'none' || fetchingAiApiKey.value || loadingAiApiKey.value) return;
    let value = aiApiKey.value || '';
    if (!value && (aiPlatform.value === 'claude' || aiPlatform.value === 'openai')) {
        loadingAiApiKey.value = true;
        startAiApiKeyDots();
        try {
            value = (await loadAiApiKeyPrivately(aiPlatform.value)) || '';
        } finally {
            loadingAiApiKey.value = false;
            stopAiApiKeyDots();
        }
    }
    inputAiApiKey = value;
    modifyMode.aiApiKey = true;
    nextTick(() => {
        focus_aiApiKey.value?.focus();
    });
};

let saveAiApiKey = async () => {
    let key = inputAiApiKey.trim();
    if (!key) return;

    updatingValue.aiApiKey = true;
    try {
        let isUpdate = !!aiApiKey.value;
        await currentService.value.registerClientSecret({
            id: aiPlatform.value,
            key,
            // Tracks "Allow anonymous users": a locked (grp 1) key makes the
            // backend refuse every unauthenticated chat send. See aiClientSecretGrp.
            grp: aiClientSecretGrp(currentService.value),
            req: isUpdate ? 'update' : 'create',
        });
        await currentService.value.setServiceOption({ ai_agent: buildAiAgentValue(aiPlatform.value) });
        aiApiKey.value = key;
        modifyMode.aiApiKey = false;

        // sync lightweight cache used by dashboard and agent page
        let serviceId = currentService.value.id;
        aiApiKeyCache[serviceId] = {
            ...(aiApiKeyCache[serviceId] || {}),
            [aiPlatform.value]: key,
        };

        // Persist the last key privately so we can prefill the API-key
        // input next time the user opens it on another surface.
        if (aiPlatform.value === 'claude' || aiPlatform.value === 'openai') {
            void saveAiApiKeyPrivately(serviceId, aiPlatform.value, key);
        }

        // sync pager cache only if it already exists (client_secret page was visited)
        let pager = serviceClientSecrets[serviceId];
        if (pager) {
            let mapped = {
                name: aiPlatform.value,
                client_secret: key,
                locked: true,
            };
            if (isUpdate && pager.list[aiPlatform.value]) {
                await pager.editItem(mapped);
            } else {
                await pager.insertItems([mapped]);
            }
        }

        // Now that we have a (potentially new) API key, refetch the model list.
        // The previous fetch may have failed (showing "Invalid API Key") so we
        // must invalidate the shared cache before triggering the refetch.
        // We await the refetch so we can surface an "invalid API key" alert
        // when the platform rejects the new key.
        if (aiPlatform.value === 'claude' || aiPlatform.value === 'openai') {
            const platform = aiPlatform.value;
            // The key just changed, so any recorded verdict describes the OLD
            // key and must be dropped, or a good key inherits "Invalid API Key".
            invalidateApiKeyVerdict(currentService.value.id, platform);
            aiModelsError.value = false;
            const token = ++aiPlatformFetchToken;
            await fetchAiModels(platform, token);
            // Deliberately NOT validated here. Validating meant spending a
            // provider call whose failure modes (queue, proxy, timeout, rate
            // limit, outage) are indistinguishable from a bad key, so a working
            // key was regularly reported as invalid. A wrong key now surfaces
            // where it actually matters: the first chat message returns the
            // provider's own key error, which raises the overlay in the chat.
        }
    } 
    // catch (err: any) {
    //     if (!(err instanceof SkapiError)) throw err;
    //     alert(err.message || err);
    // } 
    finally {
        updatingValue.aiApiKey = false;
    }
};
</script>

<style lang="less" scoped>
@import "@/assets/less/bq-tokens.less";

.bq-dashboard {
    font-family: @mono;
    color: @ink;
}

.bq-dash-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1.5rem;
    gap: 1rem;
    // padding: 0 0 0 0.5rem;
}

.bq-dash-title {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
    min-width: 0;
}

.bq-title {
    font-size: 1.1rem;
    font-weight: 600;
    // margin: 0;
    margin: 0.35rem 0;
    letter-spacing: -0.01em;
    word-break: break-word;
    // padding-left: .5rem;
}

// .bq-upgrade-btn {
//     display: inline-block;
//     font-size: 0.82rem;
//     color: @paper;
//     text-decoration: none;
//     padding: 0.5rem 1rem;
//     border: 1px solid @ink;
//     background: @ink;
//     transition: background 0.15s, color 0.15s;
//     margin-top: 1rem;
//     align-self: flex-end;

//     &:hover {
//         background: @paper;
//         color: @ink;
//     }
// }

/* --- chat link card (top of page) --- */
// Carries the same extruded border+shadow as .bq-meta so it reads as part of
// the page, but on the pink surface so the eye lands on it first.
.bq-share {
    margin-bottom: 1.5rem;
    border: 1px solid @form-line;
    // background: @pink-bg;
    padding: 1rem;
    box-shadow: 2px 2px var(--bq-shadow);
}

.bq-share-head {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    margin-bottom: 0.85rem;
}

.bq-share-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: @ink;
}

.bq-share-hint {
    font-size: 0.75rem;
    color: @muted;
    line-height: 1.4;
}

.bq-share-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
    border: 1px solid @form-line;
    background: @paper;
    padding: 0.55rem 0.5rem 0.55rem 0.75rem;
}

// The address itself. It is the whole point of the card, so it gets the largest
// type on it and, on a narrow bar, the whole first line.
.bq-share-url {
    // flex: 1 1 14rem;
    min-width: 0;
    font-family: @mono;
    font-size: 0.95rem;
    // font-weight: 600;
    color: @pink;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
        text-decoration: underline;
    }

    &.disabled {
        color: @muted;
        pointer-events: none;
        text-decoration: none;
    }
}

.bq-share-actions {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    flex-shrink: 0;
}

// One rule for both the <button> and the <a>: base.less gives every <button>
// the extruded shadow and the hover/press motion, but an anchor gets none of
// it, so the pair would sit at different heights and move differently. Spelling
// both out here keeps them identical whichever element they are.
.bq-share-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.4rem 0.7rem;
    border: 1px solid @ink;
    background: @ink;
    color: @paper;
    font-family: @mono;
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    line-height: 1.2;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    box-shadow: 2px 2px var(--bq-shadow);
    transition: transform 0.12s ease, box-shadow 0.12s ease;

    &:hover {
        text-decoration: none;
    }

    // Only where hover is a real pointer state; a touch screen emulates it on
    // tap and would leave the button stuck raised (same guard as base.less).
    @media (hover: hover) and (pointer: fine) {
        &:hover {
            transform: translate(-1px, -1px);
            box-shadow: 3px 3px var(--bq-shadow);
        }
    }

    &:active {
        transform: translate(2px, 2px);
        box-shadow: none;
        transition-duration: 0.04s;
    }

    // Held for ~1.6s after a copy so the click has a visible answer.
    &.copied {
        border-color: @success;
        background: @success;
        color: @paper;
    }

    &--ghost {
        border-color: @input-line;
        background: @paper;
        color: @ink;

        &:hover {
            border-color: @ink;
            background: @hover-bg;
            color: @ink;
        }
    }

    &.disabled {
        opacity: 0.45;
        pointer-events: none;
    }
}

.bq-share-btn-icon {
    font-size: 1rem;
    line-height: 1;
}

.bq-share-note {
    display: block;
    margin-top: 0.6rem;
    font-size: 0.72rem;
    color: @muted;
}

.bq-share--empty {
    border-color: @form-line;
    background: @paper;

    .bq-share-head {
        margin-bottom: 0;
    }
}

@media (max-width: 480px) {
    .bq-share-actions {
        width: 100%;
    }

    .bq-share-btn {
        flex: 1;
        justify-content: center;
    }
}

/* --- sections --- */
.bq-section {
    margin-bottom: 2.5rem;

    &.disabled {
        opacity: 0.5;
        pointer-events: none;
    }
}

.bq-section-title {
    font-size: 1.1rem;
    font-weight: 700;
    margin: 0 0 1.25rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid @form-line;
}

/* --- rows --- */
.bq-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.85rem 0;
    border-bottom: 1px solid @form-line;
    font-size: 0.85rem;

    &:first-of-type {
        padding-top: 0;
    }

    &:last-of-type {
        border-bottom: none;
        padding-bottom: 0;
    }
}

.bq-row-label {
    min-width: 7rem;
    font-weight: 600;
    font-size: 0.78rem;
    letter-spacing: 0.04em;
    color: @muted;
    text-transform: uppercase;
    flex-shrink: 0;
}

.bq-row-value {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bq-mono {
    font-family: @mono;
    font-size: 0.82rem;
}

/* --- select --- */
.bq-ai-select {
    position: relative;
    width: 220px;
}

/* The context window row says two numbers per option ("880K (748K input)"). */
.bq-ai-select--wide {
    width: 280px;
}

.bq-ai-select-native {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    min-height: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 2;
}

.bq-ai-select-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    padding: 0.45rem 0.75rem;
    border: 1px solid @input-line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.82rem;
    cursor: pointer;

    &:not(:disabled):hover,
    &.open {
        border-color: @ink;
    }
}

.bq-ai-select-value {
    display: inline-flex;
    align-items: center;
    gap: 0.45rem;
    min-width: 0;
}

.bq-ai-caret {
    color: @muted;
}

.bq-ai-options {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    z-index: 20;
    border: 1px solid @input-line;
    background: @paper;
    box-shadow: 2px 2px var(--bq-shadow);
    display: flex;
    flex-direction: column;
}

.bq-model-options {
    max-height: 240px;
    overflow-y: auto;
    /* overflow-x and the scrollbar lane: bq-shared.less, dropdown option rows */
}

.bq-ai-option {
    border: 0;
    border-bottom: 1px solid @line;
    background: transparent;
    box-shadow: none;
    width: 100%;
    text-align: left;
    padding: 0.45rem 0.75rem;
    font-family: @mono;
    font-size: 0.82rem;
    color: @ink;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.45rem;
    cursor: pointer;

    &:last-child {
        border-bottom: 0;
    }

    &:hover {
        background: @hover-bg;
    }

    &.active {
        background: @hover-bg;
    }
    /* no lift, no press shift: bq-shared.less, dropdown option rows */
}

.bq-ai-logo {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
}

/* --- plan header --- */
.bq-plan-header {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.bq-renew {
    font-size: 0.78rem;
    color: @muted;
}

/* --- meta --- */
.bq-meta {
    margin-bottom: 1.5rem;
    border: 1px solid @form-line;
    padding: 1rem;
    box-shadow: 2px 2px var(--bq-shadow);
}

.bq-meta-row {
    display: flex;
    justify-content: space-between;
    padding: 0.35rem 0;
    font-size: 0.78rem;

    span:first-child {
        color: @muted;
        min-width: 5rem;
    }

    span:last-child {
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}

/* --- usage bars --- */
.bq-usage-bars {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.bq-usage-item {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
}

.bq-usage-head {
    display: flex;
    justify-content: space-between;
    font-size: 0.78rem;
    color: @muted;
}

.bq-bar {
    height: 6px;
    background: @line;
    overflow: hidden;
}

.bq-bar-fill {
    height: 100%;
    background: @light-pink;
    transition: width 0.3s ease;

    &.bq-bar--warn {
        background: @warning-border;
    }

    &.bq-bar--danger {
        background: @danger;
    }

    // Over the limit on a plan that bills the excess: informational, not alarming.
    &.bq-bar--over {
        background: @info;
    }
}

// The file pool: three segments of one track. Colours are per bucket and never
// change with the level; the track's ring says how full the pool is.
.bq-bar--stacked {
    display: flex;
    box-sizing: border-box;

    &.bq-bar--warn {
        box-shadow: 0 0 0 1px @warning-border;
    }

    &.bq-bar--danger {
        box-shadow: 0 0 0 1px @danger;
    }

    &.bq-bar--over {
        box-shadow: 0 0 0 1px @info;
    }
}

.bq-bar-seg {
    height: 100%;
    flex: 0 0 auto;
    transition: width 0.3s ease;
}

.bq-bar-seg--host {
    background: @info;
}

.bq-bar-seg--cloud {
    background: @light-pink;
}

.bq-bar-seg--file {
    background: @success;
}

.bq-usage-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 0.35rem 1rem;
    font-size: 0.72rem;
    color: @muted;
}

.bq-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;

    span {
        color: @ink;
    }
}

// A meter line that reports a block in force (code/plan-copy.ts MeterNote).
.bq-usage-alert {
    color: @danger;
}

.bq-legend-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
}

.bq-plan-cta {
    margin-top: 1rem;
    text-align: right;

    /* Shrink the link to the button it wraps, so nothing but the button takes
       the click. */
    a {
        display: inline-block;
    }
}

/* --- overage (month to date) --- */
.bq-overage {
    margin-top: 1.25rem;
    padding-top: 1rem;
    border-top: 1px solid @form-line;
}

.bq-overage-title {
    margin: 0 0 0.35rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: @muted;
}

.bq-overage-total {
    border-top: 1px solid @form-line;
    font-weight: 600;

    span:first-child {
        color: @ink;
    }
}

.bq-overage-note {
    margin: 0.5rem 0 0;
    font-size: 0.78rem;
    color: @muted;

    // The hard stop line stands alone under the meters, with no block above it.
    &.bq-overage-note--alone {
        margin-top: 1rem;
    }
}

/* --- toggle rows --- */
.bq-toggle-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.85rem 0;
    border-bottom: 1px solid @form-line;
    gap: 1rem;

    &:first-of-type {
        border-top: 0;
        padding-top: 0;
    }

    &:last-of-type {
        border-bottom: 0;
        padding-bottom: 0;
    }
}

.bq-toggle-label {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;

    span {
        font-size: 0.88rem;
        font-weight: 500;
    }
}

.bq-toggle-hint {
    font-size: 0.72rem;
    color: @muted;
    font-weight: 400;
    line-height: 1.4;
}

.bq-api-key-value {
    display: block;
    max-width: 100%;
    min-height: 1.4em;
}

.bq-api-key-slot {
    display: inline-flex;
    align-items: center;
    max-width: 100%;
    min-height: 1.4em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.bq-api-key-row .bq-toggle-label {
    flex: 1;
    min-width: 0;
}

.bq-danger {
    color: @danger;
    font-size: 0.82rem;
}

/* --- modal (service-specific) --- */
.bq-modal-input {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid @input-line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.9rem;
    outline: none;
    margin-bottom: 0.75rem;
    border-radius: 0;
    transition: border-color 0.15s;

    &::placeholder { color: @placeholder; }
    &:focus { border-color: @ink; }
}

.bq-modal-textarea {
    width: 100%;
    padding: 0.75rem 1rem;
    border: 1px solid @input-line;
    background: @paper;
    color: @ink;
    font-family: @mono;
    font-size: 0.9rem;
    outline: none;
    margin-bottom: 0.75rem;
    border-radius: 0;
    transition: border-color 0.15s;
    resize: vertical;
    min-height: 4rem;
    word-wrap: break-word;
    overflow-x: hidden;
    white-space: pre-wrap;

    &::placeholder { color: @placeholder; }
    &:focus { border-color: @ink; }
    &:disabled { opacity: 0.5; cursor: default; }
}

.btn {
    width: 100%;
}

.bq-link {
    left: -2px;
    position: relative;
}

/* Two bracket actions on one row ([Revert] [Update]). */
.bq-row-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-shrink: 0;
}

/* --- responsive --- */
@media (max-width: 600px) {
    .bq-dash-header {
        flex-direction: column;
        gap: 1rem;
    }

    .bq-row {
        flex-wrap: wrap;
        gap: 0.25rem 1rem;
    }

    .bq-row-label {
        min-width: 100%;
    }

    .bq-meta-row {
        flex-direction: column;
        gap: 0.15rem;

        span:last-child {
            text-align: left;
        }
    }
}
</style>
